/* =========================================================
   Okendo Loyalty – Frontend integration (rebased on your original)
   Quiet logs by default. Turn on with:  window.OKENDO_DEBUG = true
   ========================================================= */

/* --- Okendo Loyalty: legacy DOM shims ------------------------------------ */
/* Purpose: The old #oke-loyalty-account and #oke-loyalty-vip containers
   have been replaced by app embeds. This shim prevents any code in this
   file from throwing when those legacy nodes are absent. It creates hidden,
   inert placeholders on demand and returns them to any legacy selector calls.
--------------------------------------------------------------------------- */

(function legacyDomShims() {
  var LEGACY_IDS = new Set(['oke-loyalty-account', 'oke-loyalty-vip']);

  // Track original presence (for debugging/feature flags if needed later)
  window.OKENDO_LEGACY = {
    hasAccountContainer: !!document.getElementById('oke-loyalty-account'),
    hasVipContainer: !!document.getElementById('oke-loyalty-vip')
  };

  function ensureHiddenStub(id) {
    var el = document.getElementById(id);
    if (el) return el;

    var stub = document.createElement('div');
    stub.id = id;
    // make it inert and invisible
    stub.setAttribute('data-okendo-legacy-stub', 'true');
    stub.style.display = 'none';
    stub.style.visibility = 'hidden';
    stub.style.pointerEvents = 'none';
    document.body.appendChild(stub);
    return stub;
  }

  // Patch getElementById
  var _origGetById = document.getElementById.bind(document);
  document.getElementById = function(id) {
    if (LEGACY_IDS.has(String(id))) {
      return ensureHiddenStub(String(id));
    }
    return _origGetById(id);
  };

  // Patch querySelector for ID lookups of the two legacy nodes
  var _origQS = Document.prototype.querySelector;
  Document.prototype.querySelector = function(sel) {
    if (typeof sel === 'string' && sel.charAt(0) === '#') {
      var id = sel.slice(1);
      if (LEGACY_IDS.has(id)) {
        return ensureHiddenStub(id);
      }
    }
    return _origQS.call(this, sel);
  };
})();


/* =========================
   0) CONFIG
   ========================= */
const OKENDO_USERNAME = "86456fb4-1b89-47a2-b20d-6fd4541dc279";
const OKENDO_PASSWORD = "72c37bcea9a04e41edfde65ca729f65fab5bc65ebffe15fdfc08a8da448aaedf";
const OKENDO_BASE = "https://api.okendo.io/enterprise";

/* If you stand up a same-origin proxy, put its base here (optional).
   Example: "/apps/okendo-activities"
   It should accept: ?customerId=...&limit=...&namespace=...
   Leave null to call Okendo directly (may be blocked by CORS). */
const OKENDO_ACTIVITIES_PROXY = null;

// VIP progress is based on YEAR-TO-DATE SPEND (adjust $ thresholds as needed)
const VIP_SPEND_THRESHOLDS = {
  "Bronze Wing": 0,
  "Silver Decoy": 250,
  "Gold Sprig": 500,
  "Platinum Drake": 850
};

// Optional: add your app/proxy endpoint that returns { ytdSpend: number }
const SHOPIFY_SPEND_PROXY = null; // e.g. "/apps/loyalty/ytd-spend"

let __ok_vipTierName = null;
let __ok_minVipTierName = null;
let __ok_ytdSpend = null;

function yearStartISO() {
  const d = new Date();
  return new Date(d.getFullYear(), 0, 1).toISOString();
}

function spendProgress(tierName, ytd) {
  const order = ["Bronze Wing","Silver Decoy","Gold Sprig","Platinum Drake"];
  const idx = Math.max(0, order.indexOf(tierName || "Bronze Wing"));
  const curT = VIP_SPEND_THRESHOLDS[order[idx]] ?? 0;
  const nextTier = order[Math.min(idx + 1, order.length - 1)];
  const nextT = VIP_SPEND_THRESHOLDS[nextTier] ?? curT;
  const atTop = nextTier === order[idx];
  const denom = Math.max(1, nextT - curT);
  const numer = Math.max(0, Math.min(denom, ytd - curT));
  const pct = atTop ? 100 : Math.round((numer / denom) * 100);
  return { current: order[idx], next: atTop ? null : nextTier, remaining: Math.max(0, nextT - ytd), pct, min: curT, max: nextT, ytd };
}


/* Build Basic auth header (or use theme-provided) */
const BASIC_AUTH =
  (typeof window !== "undefined" && window.OKENDO_BASIC)
    ? window.OKENDO_BASIC
    : (typeof btoa === "function"
        ? "Basic " + btoa(`${OKENDO_USERNAME}:${OKENDO_PASSWORD}`)
        : (typeof Buffer !== "undefined"
            ? "Basic " + Buffer.from(`${OKENDO_USERNAME}:${OKENDO_PASSWORD}`).toString("base64")
            : null));

if (typeof window !== "undefined") {
  window.OKENDO_BASIC_AUTH_HEADER = BASIC_AUTH; // expose for any other script
}

/* ---- Persistent debug flag (URL/hash/localStorage) ---- */
(function bootOkendoDebug(){
  let on = false;
  try {
    const u = new URL(location.href);
    if (u.searchParams.get('okdbg')) on = true;
    if ((u.hash || '').toLowerCase().includes('okdbg')) on = true;
    const ls = (localStorage.getItem('OKENDO_DEBUG') || '').toLowerCase();
    if (ls === '1' || ls === 'true') on = true;
  } catch(_) {}
  if (typeof window !== 'undefined') {
    if (window.OKENDO_DEBUG === true) on = true; // respect theme toggle if set
    window.OKENDO_DEBUG = on;
    window.okendoDebugOn  = () => { try{localStorage.setItem('OKENDO_DEBUG','1');}catch(_){}; window.OKENDO_DEBUG = true; console.log('[Okendo] debug enabled'); };
    window.okendoDebugOff = () => { try{localStorage.removeItem('OKENDO_DEBUG');}catch(_){}; window.OKENDO_DEBUG = false; console.log('[Okendo] debug disabled'); };
  }
})();


function _debugOn(){ return (typeof window !== "undefined" && window.OKENDO_DEBUG === true); }

// Quiet-by-default console helpers (ES5-safe)
(function(){
  function makeLogger(method){
    return function(){
      try{
        // Only log when debug is ON (no “errors always log”)
        if (!_debugOn()) return;
        var c  = (typeof window !== 'undefined' && window.console) ? window.console : {};
        var fn = c[method] || c.log || function(){};
        var args = Array.prototype.slice.call(arguments);
        args.unshift('[Okendo]');
        try { fn.apply(c, args); }
        catch (e) { try { fn(args.join(' ')); } catch(_){} }
      } catch(_) {}
    };
  }
  window.dbg  = makeLogger('log');   // debug/info
  window.dbgw = makeLogger('warn');  // warnings
  window.dbge = makeLogger('error'); // errors (also gated by debug)
})();



/* Must exist BEFORE any use */
function hasOkendoCreds() {
  const ok = Boolean(OKENDO_USERNAME && OKENDO_PASSWORD && BASIC_AUTH);
  if (!ok) dbgw("Missing credentials: showing non-member UI.");
  return ok;
}

let __ok_redemptionCtx = null; // holds ruleId + conversion for the slider
let __ok_waysWired = false;    // guard to avoid double-wiring earn tiles

/* Tier thresholds & labels for the single-segment journey bar */
const OK_TIERS = [
  { name: "Bronze Wing",    threshold: 0,   meta: "Sign up"   },
  { name: "Silver Decoy",   threshold: 250, meta: "250+ pts"  },
  { name: "Gold Sprig",     threshold: 500, meta: "500+ pts"  },
  { name: "Platinum Drake", threshold: 850, meta: "850+ pts"  },
];




const ACTION_TO_TILE = {
  'sign-up':          'join_program',
  'purchase':         'place_order',
  'submit-review':    'write_review',
  'birthday':         'birthday',
  'anniversary':      'anniversary',
  'facebook-like':    'facebook_like',
  'instagram-follow': 'instagram_follow',
  'referral-invite':  'refer_friend'
};

/* =========================================================
   1) Utilities
   ========================================================= */

   async function okFetchSpendFromProfiles(customerId){
  try{
    const res = await fetchJson(`${OKENDO_BASE}/customers/${customerId}/profiles`);
    const profiles = Array.isArray(res?.profiles) ? res.profiles : [];
    const rxName = /(spend|spent|revenue|purchase|order(?:s)?|amount)/i;
    const rxYTD  = /(ytd|year[\s_-]*to[\s_-]*date|this[\s_-]*year|current[\s_-]*year|\b20[2-3]\d\b)/i;

    let ytd = null, lifetime = null;
    for (const p of profiles){
      for (const prop of (p.properties || [])){
        const name = `${p.namespace || ''} ${prop?.name || ''}`;
        const val  = prop?.value;
        if (rxName.test(name) && typeof val === 'string'){
          const num = parseFloat(val.replace(/[^0-9.]/g,''));
          if (!isNaN(num)){
            if (rxYTD.test(name)) ytd = num;
            if (/lifetime|all[\s_-]*time|total/i.test(name)) lifetime = num;
          }
        }
      }
    }
    if (_debugOn()){
      console.groupCollapsed('[Okendo] profiles spend probe');
      console.log('YTD:', ytd, 'lifetime:', lifetime);
      console.groupEnd();
    }
    return ytd;
  } catch(e){
    dbgw('profiles spend probe failed:', e?.message || e);
    return null;
  }
}

async function fetchYTDSpendViaProxy(email){
  if (!SHOPIFY_SPEND_PROXY) return null;
  try{
    const u = new URL(SHOPIFY_SPEND_PROXY, location.origin);
    u.searchParams.set('email', email);
    u.searchParams.set('since', yearStartISO());
    const out = await fetchJson(u.toString(), { noAuth: true });
    const n = Number(out?.ytdSpend);
    return isFinite(n) ? n : null;
  }catch(e){
    dbgw('spend proxy failed:', e?.message || e);
    return null;
  }
}

async function resolveYTDSpend(email){
  // Prefer a globally-visible lookup if it exists
  const lookupFn =
    (typeof okLookupCustomerIdByEmail === 'function')
      ? okLookupCustomerIdByEmail
      : (typeof window !== 'undefined' && typeof window.okLookupCustomerIdByEmail === 'function')
        ? window.okLookupCustomerIdByEmail
        : null;

  let customerId = null;

  if (lookupFn) {
    try { customerId = await lookupFn(email); }
    catch(e){ dbgw('customerId lookup via fn failed:', e?.message || e); }
  }

  // Fallback: call Okendo customer_lookup directly
  if (!customerId) {
    try {
      const out = await fetchJson(`${OKENDO_BASE}/customer_lookup`, {
        method: 'POST',
        body: JSON.stringify({ email })
      });
      customerId = out?.customerId || null;
    } catch(e){
      dbgw('customer_lookup fallback failed:', e?.message || e);
    }
  }

  // Try Okendo Profiles for spend first
  if (customerId){
    const ytd = await okFetchSpendFromProfiles(customerId);
    if (ytd != null) return ytd;
  }

  // Last resort: your Shopify proxy
  return await fetchYTDSpendViaProxy(email);
}



function hardDisableBtn(btn){
  if (!btn) return;
  btn.disabled = true;                         // works if it's a <button>
  btn.setAttribute('aria-disabled', 'true');   // announces "disabled" to AT
  btn.setAttribute('tabindex', '-1');          // skip in tab order
  btn.classList.add('is-disabled');
  if (btn.tagName === 'A') {                   // kill anchor navigation
    btn.dataset.oldHref = btn.getAttribute('href') || '';
    btn.removeAttribute('href');
  }
}

function markTileComplete(tile, btn, label = 'Completed'){
  if (btn){
    btn.textContent = label;
    hardDisableBtn(btn);
  }
  if (tile){ tile.classList.add('is-complete'); }
}

function injectDisabledBtnCss(){
  if (document.getElementById('ok-disabled-btn-css')) return;
  const css = `
    /* Visually and interactively disable completed/disabled earn buttons */
    [data-earn-tile].is-complete [data-earn-btn],
    [data-earn-btn].is-disabled,
    [data-earn-btn][aria-disabled="true"],
    [data-earn-btn][disabled]{
      pointer-events: none !important;
      cursor: not-allowed !important;
      opacity: .6;
    }
  `;
  const tag = document.createElement('style');
  tag.id = 'ok-disabled-btn-css';
  tag.textContent = css;
  document.head.appendChild(tag);
}

async function fetchJson(url, opts = {}) {
  dbg("fetchJson →", url, opts?.method || "GET");
  const { noAuth, headers: extraHeaders, ...rest } = opts;
  const res = await fetch(url, {
    ...rest,
    headers: {
      ...(noAuth ? {} : { "Authorization": BASIC_AUTH || "" }),
      "Accept": "application/json",
      "Content-Type": "application/json",
      ...(extraHeaders || {})
    },
    credentials: "omit",
    mode: "cors",
  });
  const text = await res.text().catch(() => "");
  if (!res.ok) {
    dbge("HTTP error", res.status, url, text?.slice?.(0, 400));
    let body = text;
    try { body = JSON.stringify(JSON.parse(text)); } catch (_) {}
    throw new Error(`Okendo ${res.status} : ${body || url}`);
  }
  let json = {};
  try { json = text ? JSON.parse(text) : {}; } catch (e) { dbge("JSON parse error for", url, e); }
  dbg("fetchJson ✓", url, "(keys:", Object.keys(json), ")");
  return json;
}

function setText(sel, text) { const el = document.querySelector(sel); if (el) el.textContent = text; }
function $(sel, ctx = document) { return ctx.querySelector(sel); }
function $all(sel, ctx = document) { return Array.from(ctx.querySelectorAll(sel)); }
function numberFrom(el) { if (!el) return 0; const n = parseInt((el.textContent || "").replace(/[^\d]/g, ""), 10); return isNaN(n) ? 0 : n; }

/* Formatting */
function fmtMoney(n) { if (n == null || isNaN(n)) return "—"; return `$${Number(n).toFixed(2)}`; }
function fmtDate(iso) { if (!iso) return "—"; const d = new Date(iso); if (isNaN(d)) return "—"; return d.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }); }

/* Shopify customer detection (strict) */
function getShopifyCustomerEmail() {
  const v = (typeof window !== "undefined" ? window.__customerEmail : null);
  if (typeof v === "string" && /\S+@\S+\.\S+/.test(v)) return v.trim();
  return null;
}

function titleCase(s) {
  return String(s || "")
    .split(/[\s._-]+/)
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

function getCustomerDisplayName(loyalty) {
  const email = getShopifyCustomerEmail();
  const val = v => (typeof v === "string" ? v.trim() : "");
  const join = (a, b) => (val(a) || val(b)) ? `${val(a)} ${val(b)}`.trim() : "";

  const candidates = [
    (typeof window !== "undefined" && val(window.__customerName)),
    join(loyalty?.customer?.firstName, loyalty?.customer?.lastName),
    join(loyalty?.firstName, loyalty?.lastName),
    val(loyalty?.name),
    val(loyalty?.customerName),
    val(loyalty?.profile?.name),
  ].filter(Boolean);

  if (candidates.length) return candidates[0];
  if (email) return titleCase(email.split("@")[0].replace(/[._]+/g, " "));
  return "Member";
}


/* Tier math */
function getTierIndex(points) { if (points >= 850) return 3; if (points >= 500) return 2; if (points >= 250) return 1; return 0; }
function nextTierTarget(points) {
  if (points >= 850) return { label: "You're at the top tier", target: 850, next: null, remaining: 0, min: 850 };
  if (points >= 500) return { label: "to Platinum Drake", target: 850, next: 850, remaining: Math.max(0, 850 - points), min: 500 };
  if (points >= 250) return { label: "to Gold Sprig", target: 500, next: 500, remaining: Math.max(0, 500 - points), min: 250 };
  return { label: "to Silver Decoy", target: 250, next: 250, remaining: Math.max(0, 250 - points), min: 0 };
}
function isNotFoundError(err) { return err && typeof err.message === "string" && err.message.includes(" 404 "); }

// normalizes strings for fuzzy compares
function nrm(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[^\w]+/g, ' ') // keep words
    .trim();
}

// returns a Set of action slugs detected in profile properties
function detectSocialCompletionsFromProfiles(profiles = []) {
  const done = new Set();

  // scan every [namespace, name, value] triple
  for (const p of (profiles || [])) {
    const ns  = nrm(p.namespace);
    for (const prop of (p.properties || [])) {
      const name = nrm(prop.name);
      const val  = nrm(prop.value);
      const blob = `${ns} ${name} ${val}`;

      // very tolerant matching (covers many naming schemes)
      if (/\bfacebook\b/.test(blob) && (/\blike\b/.test(blob) || /\bfollow\b/.test(blob))) {
        done.add('facebook-like');
      }
      if (/\binstagram\b/.test(blob) && /\bfollow\b/.test(blob)) {
        done.add('instagram-follow');
      }
      if (/\btik[\s-]?tok\b/.test(blob) && /\bfollow\b/.test(blob)) {
        done.add('tiktok-follow');
      }
      // you can add more heuristics here as needed
    }
  }

  if (done.size) {
    console.groupCollapsed('[Okendo][earn] profiles → social completions');
    console.log([...done]);
    console.groupEnd();
  }
  return done;
}


/* Clipboard helpers */
async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}

/* Make <a> behave like a button, cancel default nav, and gate login */
function armEarnBtn(btn, onClick) {
  if (!btn) return;
  if (btn.dataset.okWired === '1') return;                     // already wired
  if (btn.disabled || btn.getAttribute('aria-disabled')==='true' ||
      btn.classList.contains('is-disabled') || btn.classList.contains('is-complete')) return; // don't wire disabled

  const prev = btn.getAttribute('href') || '';
  btn.dataset.oldHref = prev;          // keep for debugging
  btn.setAttribute('href', '#');       // neutralize default nav
  btn.setAttribute('role', 'button');
  btn.setAttribute('tabindex', '0');
  btn.removeAttribute('target');

  const fire = (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    } catch (_) {}
    const email = getShopifyCustomerEmail();
    if (!email) {
      // If logged-out, send to login and come back here
      const ret = location.pathname + location.search + location.hash;
      location.href = `/account/login?return_url=${encodeURIComponent(ret)}`;
      return;
    }
    onClick(email, btn, e);
  };

  try { btn.addEventListener('click', fire); } catch(_) {}
  try { btn.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') fire(e); }); } catch(_) {}

  btn.dataset.okWired = '1';
}


/* =========================================================
   1.5) Visibility helpers (guest by default; only touch gated nodes)
   ========================================================= */
function normState(s) {
  const x = String(s || "").trim().toLowerCase();
  if (/^(non[-_\s]?member|guest|logged[-_\s]?out|public)$/.test(x)) return "non-member";
  if (/^(member|logged[-_\s]?in|auth)$/.test(x)) return "member";
  return "non-member";
}
function parseStateList(attrValue) {
  const out = new Set();
  String(attrValue || "")
    .split(/[\s,|]+/)
    .map(s => s.trim().toLowerCase())
    .filter(Boolean)
    .forEach(v => {
      if (v === "guest" || v === "logged-out" || v === "public" || v === "nonmember") v = "non-member";
      if (v === "loggedin") v = "logged-in";
      out.add(v);
    });
  return out;
}
function attrMatches(el, attr, stateNorm) {
  if (!el.hasAttribute(attr)) return null;
  const vals = parseStateList(el.getAttribute(attr));
  const isLoggedIn = !!getShopifyCustomerEmail();
  if (vals.has("all") || vals.has("any") || vals.has("both")) return true;
  if (vals.has("logged-in"))  return isLoggedIn;
  if (vals.has("logged-out")) return !isLoggedIn;
  if (vals.has("member") || vals.has("non-member")) return vals.has(stateNorm);
  return null;
}
function showHide(el, show) {
  if (show) {
    if (el.dataset.prevDisplay != null) {
      el.style.display = el.dataset.prevDisplay;
      delete el.dataset.prevDisplay;
    } else {
      el.style.removeProperty("display");
    }
    el.hidden = false;
  } else {
    if (el.dataset.prevDisplay == null) el.dataset.prevDisplay = el.style.display || "";
    el.style.display = "none";
    el.hidden = true;
  }
}

/* =========================================================
   2) DOMContentLoaded – wiring
   ========================================================= */
document.addEventListener("DOMContentLoaded", () => {
  dbg("DOMContentLoaded");
  const ROOTS = Array.from(document.querySelectorAll('.okendo-loyalty-root, #okendo-loyalty-root'));
  const FALLBACK = ROOTS.length === 0;                  // if no dedicated root, operate against the whole document
  const SCOPES = FALLBACK ? [document] : ROOTS;
  const OKENDO_EMBED_REFERRAL = !!document.querySelector('.refer-banner__content .refer-app');

  function forEachScope(fn){
    SCOPES.forEach(scope => { try { fn(scope); } catch(e){ dbgw('[scope]', e?.message || e); } });
  }
  function isLoggedIn(){ return !!getShopifyCustomerEmail(); }

  injectDisabledBtnCss();

  const loginLink = document.getElementById("login-link");
  $all('a[href^="/account/login"], a[href^="/account/register"]').forEach(a => a.removeAttribute("target"));

  function ensureLoginButtonVisibility() {
    if (!loginLink) return;
    loginLink.style.removeProperty("display");
    if (isLoggedIn()) loginLink.style.display = "none";
  }

  // Multi-root-aware visibility
  function applyVisibility(state, opts = {}) {
    const stateNorm = normState(state);
    const onlyGatedOpt = (opts.onlyGated != null) ? !!opts.onlyGated : undefined;
    dbg("applyVisibility →", stateNorm, "(onlyGated:", onlyGatedOpt, ")");

    forEachScope((scopeEl) => {
      const onlyGated = (onlyGatedOpt !== undefined)
        ? onlyGatedOpt
        : (scopeEl === document); // when using document fallback, only touch explicitly gated nodes

      const host = (scopeEl === document) ? document.body : scopeEl;
      host.setAttribute("data-loyalty-state", stateNorm);
      host.setAttribute("data-login-state", isLoggedIn() ? "logged-in" : "logged-out");

      const targets = onlyGated
        ? scopeEl.querySelectorAll("[data-visible-when], [data-hide-when]")
        : scopeEl.querySelectorAll("*");

      targets.forEach((el) => {
        let show = true;
        const v = attrMatches(el, "data-visible-when", stateNorm);
        if (v !== null) show = v;
        const h = attrMatches(el, "data-hide-when", stateNorm);
        if (h === true) show = false;
        showHide(el, show);
      });

      updateHeadingsForState(scopeEl);
      // Enforce major UI gates based on true membership state
      const isMemberState = (stateNorm === 'member');
      toggleRedeemAvailability(isMemberState);
      setJoinModeOnEarnTiles(!isMemberState);

      const callout = scopeEl.querySelector(".callout");
      if (callout) callout.style.display = (stateNorm === "member" ? "none" : "");
    });

    updateTierUI(); // global widgets
  }

  // Boot using current login state; only touch gated nodes on first pass
  applyVisibility(isLoggedIn() ? "member" : "non-member", { onlyGated: true });
  ensureLoginButtonVisibility();

  function toggleRedeemAvailability(show){
    // Hide/show the Redeem (Available) tab & panel
    document.querySelectorAll('[data-tabs]').forEach(wrap => {
      const btnAvail   = wrap.querySelector('[data-tab-btn="available"]');
      const panelAvail = wrap.querySelector('[data-tab-panel="available"]');

      if (btnAvail) {
        const btnContainer = btnAvail.closest('[data-tab-btn]') || btnAvail;
        btnContainer.style.display = show ? '' : 'none';
        btnAvail.setAttribute('aria-hidden', show ? 'false' : 'true');
        btnAvail.setAttribute('tabindex', show ? '0' : '-1');
      }
      if (panelAvail) {
        if (show) { panelAvail.style.display = ''; panelAvail.removeAttribute('hidden'); }
        else { panelAvail.style.display = 'none'; panelAvail.setAttribute('hidden',''); }
      }

      // If we hid the active tab, fall back to "history" or "redeemed"
      if (!show) {
        const active = wrap.querySelector('[data-tab-btn].is-active');
        if (active && active.dataset.tabBtn === 'available') {
          const fallback = wrap.querySelector('[data-tab-btn="history"]') || wrap.querySelector('[data-tab-btn="redeemed"]');
          if (fallback) try { fallback.click(); } catch(_) {}
        }
      }
    });
  }

  function setJoinModeOnEarnTiles(enable){
    // For custom earn tiles (outside the Okendo embed), inject/rename Join buttons
    document.querySelectorAll('[data-earn-tile]').forEach(tile => {
      let btn = tile.querySelector('[data-earn-btn]');
      if (!btn && enable){
        btn = document.createElement('a');
        btn.className = 'btn btn--primary';
        btn.setAttribute('data-earn-btn','');
        tile.appendChild(btn);
      }
      if (!btn) return;

      if (enable){
        if (!btn.dataset.okPrevText) btn.dataset.okPrevText = btn.textContent || '';
        btn.textContent = 'Join';
        btn.classList.add('ok-open-join');   // widget opener will intercept this
        btn.setAttribute('href', '#');
        btn.removeAttribute('target');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-disabled');
      } else {
        if (btn.dataset.okPrevText){ btn.textContent = btn.dataset.okPrevText; delete btn.dataset.okPrevText; }
        btn.classList.remove('ok-open-join');
      }
    });
  }



  /* Tabs */
  function initTabs() {
    dbg("initTabs");
    document.querySelectorAll("[data-tabs]").forEach((wrap) => {
      const buttons = wrap.querySelectorAll("[data-tab-btn]");
      const panels  = wrap.querySelectorAll("[data-tab-panel]");

      const activate = (name) => {
        dbg("tab activate", wrap.id, "→", name);
        buttons.forEach(b => {
          const active = b.dataset.tabBtn === name;
          b.classList.toggle("is-active", active);
          b.setAttribute("aria-selected", active ? "true" : "false");
        });
        panels.forEach(p => {
          const show = p.dataset.tabPanel === name;
          p.classList.toggle("is-active", show);
          if (show) p.removeAttribute("hidden"); else p.setAttribute("hidden", "");
        });
        if (wrap.id === "profile-tabs" && name === "history") loadPointHistoryIfNeeded();
      };

      const first = buttons[0]?.dataset.tabBtn;
      const start = [...buttons].find(b => b.classList.contains("is-active"))?.dataset.tabBtn || first;
      activate(start);

      buttons.forEach(btn => { try { btn.addEventListener("click", (e) => { e.preventDefault(); activate(btn.dataset.tabBtn); }); } catch(_) {} });
    });

    styleRedeemedPanel();
  }

  function updateHeadingsForState(scopeEl = document) {
    // detect member by email (most reliable), fall back to attribute if needed
    const member = !!getShopifyCustomerEmail() ||
                  ((scopeEl === document ? document.body : scopeEl).getAttribute('data-loyalty-state') === 'member');

    const out = scopeEl.querySelector('#redeem-title-logged-out');
    const inn = scopeEl.querySelector('#redeem-title-logged-in');
    if (out) out.style.display = member ? 'none' : '';
    if (inn) inn.style.display = member ? '' : 'none';
  }


  /* ===============================
     Single-segment tier journey bar
     =============================== */
  function renderTierJourneySingleBar(points) {
    const rootJ = document.getElementById("ok-journey");
    if (!rootJ) return;

    const fill  = rootJ.querySelector("#ok-journey-fill");
    const steps = Array.from(rootJ.querySelectorAll(".ok-journey__step"));
    const sub   = rootJ.querySelector("#ok-journey-sub");

    const maxPts = OK_TIERS[OK_TIERS.length - 1].threshold;

    let nextIdx = OK_TIERS.findIndex(t => points < t.threshold);
    if (nextIdx === -1) nextIdx = OK_TIERS.length - 1;
    const nextTier  = OK_TIERS[nextIdx];
    const remaining = Math.max(0, nextTier.threshold - points);

    if (sub) {
      sub.textContent = (nextIdx === OK_TIERS.length - 1 && points >= nextTier.threshold)
        ? "You're at the top tier"
        : `Earn ${remaining} more points to reach ${nextTier.name}`;
    }

    const pct = Math.max(0, Math.min(100, (points / maxPts) * 100));
    if (fill) fill.style.width = pct + "%";

    steps.forEach((step, i) => {
      const pos = (i / (OK_TIERS.length - 1)) * 100;
      step.style.left = pos + "%";
      step.style.transform =
        i === 0 ? "translateX(0)" :
        i === OK_TIERS.length - 1 ? "translateX(-100%)" :
        "translateX(-50%)";

      const label = step.querySelector(".ok-journey__label");
      const meta  = step.querySelector(".ok-journey__meta");
      if (label) label.textContent = OK_TIERS[i].name;
      if (meta)  meta.textContent  = OK_TIERS[i].meta;

      step.classList.remove("is-complete", "is-current", "is-future");

      const here  = OK_TIERS[i].threshold;
      const nextT = OK_TIERS[Math.min(i + 1, OK_TIERS.length - 1)].threshold;

      if (points >= nextT)        step.classList.add("is-complete");
      else if (points >= here)    step.classList.add("is-current");
      else                        step.classList.add("is-future");
    });
  }

  function updateTierUI() {
    // Prefer spend-based progress when available
    const tierFromApi = (typeof __ok_vipTierName !== 'undefined' && __ok_vipTierName) || "Bronze Wing";
    const ytd = (typeof __ok_ytdSpend !== 'undefined') ? __ok_ytdSpend : null;

    // Local safe spendProgress fallback if the helper wasn't added
    const SP_FALLBACK = (tierName, y) => {
      const THRESH = (typeof VIP_SPEND_THRESHOLDS !== 'undefined')
        ? VIP_SPEND_THRESHOLDS
        : { "Bronze Wing": 0, "Silver Decoy": 250, "Gold Sprig": 500, "Platinum Drake": 850 };
      const order = ["Bronze Wing","Silver Decoy","Gold Sprig","Platinum Drake"];
      const idx = Math.max(0, order.indexOf(tierName || "Bronze Wing"));
      const curMin = THRESH[order[idx]] ?? 0;
      const nextTier = order[Math.min(idx + 1, order.length - 1)];
      const nextMax = THRESH[nextTier] ?? curMin;
      const atTop = nextTier === order[idx];
      const denom = Math.max(1, nextMax - curMin);
      const numer = Math.max(0, Math.min(denom, (y ?? 0) - curMin));
      const pct = atTop ? 100 : Math.round((numer / denom) * 100);
      return { current: order[idx], next: atTop ? null : nextTier, remaining: Math.max(0, nextMax - (y ?? 0)), pct, min: curMin, max: nextMax, ytd: y ?? 0 };
    };

    if (ytd != null) {
      const info = (typeof spendProgress === 'function') ? spendProgress(tierFromApi, ytd) : SP_FALLBACK(tierFromApi, ytd);

      // Highlight the active tier card by name
      const names = ["Bronze Wing", "Silver Decoy", "Gold Sprig", "Platinum Drake"];
      const idxByName = Math.max(0, names.indexOf(info.current));
      document.querySelectorAll("#okendo-tier-table .tier-card")
        .forEach((c, i) => c.classList.toggle("tier-card--active", i === idxByName));

      // Global progress bar (hero)
      {
        const gBar = document.getElementById("ok-tier-progress-fill");
        const gLbl = document.getElementById("ok-tier-progress-label");
        if (gBar && gLbl) {
          gBar.style.width = `${info.pct}%`;
          gLbl.textContent = info.next ? `${fmtMoney(info.remaining)} to ${info.next}` : "Max tier reached";
        }
      }

      // Secondary progress bar (compact)
      {
        const pBar = document.getElementById("okendo-tier-progress-bar");
        const pLbl = document.getElementById("okendo-tier-progress-label");
        if (pBar && pLbl) {
          pBar.style.width = `${info.pct}%`;
          pLbl.textContent = `${fmtMoney(info.ytd)} / ${fmtMoney(info.max)}`;
        }
      }

      // Profile detail card (swap labels to dollars)
      {
        const elCurrent = document.getElementById("ok-prof-current-tier");
        const elNext    = document.getElementById("ok-prof-next-tier");
        if (elCurrent) elCurrent.textContent = info.current;
        if (elNext)    elNext.textContent    = info.next || "—";

        const neededLbl = document.getElementById("ok-prof-needed-label");
        const fill      = document.getElementById("ok-prof-detail-fill");
        const leftLbl   = document.getElementById("ok-prof-left-label");
        const rightLbl  = document.getElementById("ok-prof-right-label");
        const percentEl = document.getElementById("ok-prof-percent");

        if (neededLbl) neededLbl.textContent = info.next ? `${fmtMoney(info.remaining)} to ${info.next}` : "You're at the top tier";
        if (fill)      fill.style.width = `${info.pct}%`;
        if (leftLbl)   leftLbl.textContent  = fmtMoney(info.min);
        if (rightLbl)  rightLbl.textContent = fmtMoney(info.max);
        if (percentEl) percentEl.textContent = `${info.pct}% complete`;
      }

      // In spend mode we skip the old points-based journey bar.
      return;
    }

    // ---------- Fallback: points-based (your original) ----------
    const points = numberFrom(document.getElementById("okendo-points"));
    const idx = getTierIndex(points);

    document.querySelectorAll("#okendo-tier-table .tier-card")
      .forEach((c, i) => c.classList.toggle("tier-card--active", i === idx));

    {
      const gBar = document.getElementById("ok-tier-progress-fill");
      const gLbl = document.getElementById("ok-tier-progress-label");
      const info = nextTierTarget(points);
      if (gBar && gLbl && info) {
        const denom = (info.next ? (info.next - info.min) : 1);
        const numer = Math.max(0, Math.min(denom, points - info.min));
        gBar.style.width = `${(numer / denom) * 100}%`;
        gLbl.textContent = info.next ? `${info.remaining} points ${info.label}` : "Max tier reached";
      }
    }

    {
      const pBar = document.getElementById("okendo-tier-progress-bar");
      const pLbl = document.getElementById("okendo-tier-progress-label");
      const info2 = nextTierTarget(points);
      if (pBar && pLbl && info2) {
        const denom2 = (info2.next ? (info2.next - info2.min) : 1);
        const numer2 = Math.max(0, Math.min(denom2, points - info2.min));
        pBar.style.width = `${(numer2 / denom2) * 100}%`;
        pLbl.textContent = info2.next ? `${points} / ${info2.next}` : `${points} / 850`;
      }
    }

    {
      const info = nextTierTarget(points);
      const names = ["Bronze Wing", "Silver Decoy", "Gold Sprig", "Platinum Drake"];
      const currentTierName = names[idx] || "Bronze Wing";
      const nextTierName = info.next ? names[Math.min(idx + 1, names.length - 1)] : null;

      const elCurrent = document.getElementById("ok-prof-current-tier");
      const elBalance = document.getElementById("ok-prof-balance-pts");
      const elNext    = document.getElementById("ok-prof-next-tier");
      if (elCurrent) elCurrent.textContent = currentTierName;
      if (elBalance) elBalance.textContent = `${points} pts`;
      if (elNext)    elNext.textContent    = nextTierName || "—";

      const neededLbl = document.getElementById("ok-prof-needed-label");
      const fill      = document.getElementById("ok-prof-detail-fill");
      const leftLbl   = document.getElementById("ok-prof-left-label");
      const rightLbl  = document.getElementById("ok-prof-right-label");
      const percentEl = document.getElementById("ok-prof-percent");

      if (neededLbl) neededLbl.textContent = info.next ? `${info.remaining} points to ${nextTierName}` : "You're at the top tier";

      if (fill && leftLbl && rightLbl && percentEl) {
        const denom = info.next ? (info.next - info.min) : 1;
        const numer = Math.max(0, Math.min(denom, points - info.min));
        const pct   = Math.round((numer / denom) * 100);
        fill.style.width = `${pct}%`;
        leftLbl.textContent  = `${info.min} pts`;
        rightLbl.textContent = `${info.next || 850} pts`;
        percentEl.textContent = info.next ? `${pct}% complete` : "100% complete";
      }
    }

    renderTierJourneySingleBar(points);
  }

  function enhanceProfileCards() {
    const leftCard = document.querySelector('[data-tab-panel="profile"] .grid--2-col .grid__item.profile-card:nth-child(1)');
    if (leftCard) {
      leftCard.classList.add("ok-card");
      leftCard.innerHTML = `
        <div class="ok-card__body">
          <h3 class="ok-card__title" id="ok-name">Member</h3>
          <p class="ok-card__sub" id="ok-email"></p>
          <div class="ok-sep"></div>
          <div class="ok-kv"><span class="ok-kv__label">Your Balance</span><span class="ok-kv__value"><span id="okendo-points">0</span> Points</span></div>
          <div class="ok-kv"><span class="ok-kv__label">Member Since</span><span class="ok-kv__value" id="ok-member-since">—</span></div>
          <div class="ok-kv"><span class="ok-kv__label">Spent Since January 1</span><span class="ok-kv__value" id="ok-spent-ytd">—</span></div>
          <div class="ok-kv"><span class="ok-kv__label">Friends Referred</span><span class="ok-kv__value" id="ok-referrals">0</span></div>
        </div>`;
    }

    const rightCard = document.querySelector('[data-tab-panel="profile"] .grid--2-col .grid__item.profile-card:nth-child(2)');
    if (rightCard) {
      rightCard.classList.add("ok-card");
      rightCard.innerHTML = `
        <div class="ok-card__body">
          <h3 class="ok-card__title">Move Up Tiers</h3>
          <p class="ok-card__sub" id="ok-tier-next-line"></p>
          <div class="ok-tier-mini">
            <div class="ok-tier-mini__left">
              <div class="ok-tier-mini__step">1</div>
              <div class="ok-tier-mini__meta">
                <div class="ok-tier-mini__title" id="ok-tier-current">—</div>
                <div class="ok-tier-mini__caption">Current tier</div>
              </div>
            </div>
            <div class="ok-tier-mini__bar"><div class="ok-tier-mini__fill" id="ok-tier-mini-fill" style="width:0%"></div></div>
            <div class="ok-tier-mini__right">
              <div class="ok-tier-mini__meta ok-tier-mini__meta--right">
                <div class="ok-tier-mini__title" id="ok-tier-next">—</div>
                <div class="ok-tier-mini__caption" id="ok-tier-after-spend">After spending —</div>
              </div>
              <div class="ok-tier-mini__step ok-tier-mini__step--hollow">2</div>
            </div>
          </div>
        </div>`;
    }
  }

  function renderMemberOverview(loyalty) {
    setText("#ok-name", getCustomerDisplayName(loyalty));
    setText("#ok-email", getShopifyCustomerEmail() || "");
    const bal = Math.round(loyalty?.points?.balance ?? 0);
    setText("#okendo-points", String(bal));
    const joinedAt = loyalty?.createdAt || loyalty?.joinedAt || loyalty?.created_at;
    setText("#ok-member-since", fmtDate(joinedAt));
    const ytd = (__ok_ytdSpend != null) ? __ok_ytdSpend : null;
    setText("#ok-spent-ytd", ytd != null ? fmtMoney(ytd) : "—");
    const refs = loyalty?.referralsCount ?? loyalty?.referrals?.count ?? 0;
    setText("#ok-referrals", String(refs));
    dbg("Member overview rendered (balance:", bal, ")");
  }

  function renderMiniTier(loyalty) {
    // Prefer spend-based progress when available
    const tierFromApi = (typeof __ok_vipTierName !== 'undefined' && __ok_vipTierName) || loyalty?.vipTierName || "Bronze Wing";
    const ytd = (typeof __ok_ytdSpend !== 'undefined') ? __ok_ytdSpend : null;

    // Local safe spendProgress fallback if the helper wasn't added
    const SP_FALLBACK = (tierName, y) => {
      const THRESH = (typeof VIP_SPEND_THRESHOLDS !== 'undefined')
        ? VIP_SPEND_THRESHOLDS
        : { "Bronze Wing": 0, "Silver Decoy": 250, "Gold Sprig": 500, "Platinum Drake": 850 };
      const order = ["Bronze Wing","Silver Decoy","Gold Sprig","Platinum Drake"];
      const idx = Math.max(0, order.indexOf(tierName || "Bronze Wing"));
      const curMin = THRESH[order[idx]] ?? 0;
      const nextTier = order[Math.min(idx + 1, order.length - 1)];
      const nextMax = THRESH[nextTier] ?? curMin;
      const atTop = nextTier === order[idx];
      const denom = Math.max(1, nextMax - curMin);
      const numer = Math.max(0, Math.min(denom, (y ?? 0) - curMin));
      const pct = atTop ? 100 : Math.round((numer / denom) * 100);
      return { current: order[idx], next: atTop ? null : nextTier, remaining: Math.max(0, nextMax - (y ?? 0)), pct, min: curMin, max: nextMax, ytd: y ?? 0 };
    };

    if (ytd != null) {
      const info = (typeof spendProgress === 'function') ? spendProgress(tierFromApi, ytd) : SP_FALLBACK(tierFromApi, ytd);

      setText("#ok-tier-current", info.current);
      setText("#ok-tier-next", info.next || "—");
      setText("#ok-tier-after-spend", info.next ? `After spending ${fmtMoney(info.remaining)}` : "Max tier reached");
      setText("#ok-tier-next-line", info.next ? `Spend ${fmtMoney(info.remaining)} more to reach the ${info.next} tier.` : "You're at the top tier.");

      const bar = document.getElementById("ok-tier-mini-fill");
      if (bar) bar.style.width = `${info.pct}%`;

      dbg("Mini tier rendered (spend):", info);
      return;
    }

    // ---------- Fallback: points-based (your original) ----------
    const points = Math.round(loyalty?.points?.balance ?? 0);
    const info   = nextTierTarget(points);
    const currentTier = tierFromApi || "Bronze Wing";
    setText("#ok-tier-current", currentTier);

    const nextLabel =
      points >= 500 && points < 850 ? "Platinum Drake" :
      points >= 250 && points < 500 ? "Gold Sprig" :
      "Silver Decoy";

    if (info.next) {
      setText("#ok-tier-next", nextLabel);
      setText("#ok-tier-after-spend", `After spending ${fmtMoney(info.remaining)}`);
      setText("#ok-tier-next-line", `Spend ${fmtMoney(info.remaining)} more to reach the ${nextLabel} tier.`);
      const denom = (info.next - info.min);
      const numer = Math.max(0, Math.min(denom, points - info.min));
      const pct   = denom ? (numer / denom) * 100 : 0;
      const bar   = document.getElementById("ok-tier-mini-fill");
      if (bar) bar.style.width = `${pct}%`;
    } else {
      setText("#ok-tier-next", "—");
      setText("#ok-tier-after-spend", "Max tier reached");
      setText("#ok-tier-next-line", "You're at the top tier.");
      const bar = document.getElementById("ok-tier-mini-fill");
      if (bar) bar.style.width = "100%";
    }
    dbg("Mini tier rendered (points:", points, ")");
  }

/* ========= Redeem (Available/ Redeemed) ========= */
/**
 * Tier-aware context builder for the Redeem slider.
 * Reads Okendo redemption rules (including tier-specific shapes) and returns:
 *   - type, ruleId, awardVia
 *   - ptsPerDollar (float, not rounded)
 *   - minPointsStep, minPoints, maxPoints
 *
 * Notes:
 * - Uses __ok_vipTierName (already set from loyalty.customer.vipTierName).
 * - Supports shapes like:
 *     - single variable-value rule with reward.points/value
 *     - multiple rules, each gated by minimumVipTierName
 *     - rule.reward.tiers / rule.reward.tieredValues / rule.reward.denominations entries with {vipTierName|tierName, points, value}
 */
function getRedemptionContext(rules = [], balance = 0) {
  const list = Array.isArray(rules) ? rules : [];

  // Helpers (local to this function)
  const lower = (v) => String(v || '').toLowerCase();
  const tierOrder = (OK_TIERS || []).map(t => t && t.name).filter(Boolean); // ["Bronze Wing", ...]
  const tierIdx = (name) => {
    const i = tierOrder.indexOf(String(name || '').trim());
    return i < 0 ? 0 : i;
  };
  const curTier = (typeof __ok_vipTierName === 'string' && __ok_vipTierName) ? __ok_vipTierName : null;
  const curIdx  = tierIdx(curTier);

  const normType = r => normalizeRuleType(pickFirst(r, ['type','rule.type','reward.type']));

  // Extract awardVia from rule/reward
  const getAwardVia = (r) => pickFirst(r, ['reward.awardVia','reward.award_via','data.reward.awardVia','data.reward.award_via']) || 'coupon';

  // Try to pull an array of tier entries from a rule.
  function collectTierEntriesFrom(rule){
    const candidates = [];

    // 1) Explicit tiered arrays on common paths
    const ARR_PATHS = [
      'reward.tieredValues', 'reward.tiers', 'reward.tierRules', 'reward.tierValues',
      'tieredValues', 'tiers', 'tierRules', 'tierValues',
      'reward.denominations' // some tenants annotate denoms per tier
    ];
    for (const p of ARR_PATHS) {
      const arr = deepGet(rule, p);
      if (!Array.isArray(arr) || !arr.length) continue;

      for (const row of arr) {
        const tierName = pickFirst(row, ['vipTierName','tierName','vipTier','minimumVipTierName','tier']) || null;
        const points   = Number(pickFirst(row, ['points','amount.points','pointsRequired','points_required','points_needed']));
        const value    = Number(pickFirst(row, ['value','amount.value','rewardAmount','currencyAmount']));
        const minPts   = Number(pickFirst(row, ['minimumPoints','minPoints']));
        const maxPts   = Number(pickFirst(row, ['maximumPoints','maxPoints']));

        if (isFinite(points) && isFinite(value) && value > 0) {
          candidates.push({
            ruleId: pickFirst(rule, ['redemptionRuleId','id','ruleId']) || null,
            tierName,
            points,
            value,
            minPoints: isFinite(minPts) ? minPts : undefined,
            maxPoints: isFinite(maxPts) ? maxPts : undefined,
            step: points // typical step equals the base denomination points
          });
        }
      }
    }

    // 2) Plain rule-level points/value + (optional) tier name on the rule
    if (!candidates.length) {
      const rwd     = pickFirst(rule, ['reward','data.reward','rewardDefinition']) || {};
      const points  = Number(pickFirst(rwd, ['points','amount.points']));
      const value   = Number(pickFirst(rwd, ['value','amount.value']));
      const minPts  = Number(pickFirst(rwd, ['minimumPoints']));
      const maxPts  = Number(pickFirst(rwd, ['maximumPoints']));
      const tierOnR = pickFirst(rule, [
        'minimumVipTierName','minVipTierName','vipTierName','vipTier','tier',
        'reward.minimumVipTierName','reward.vipTierName'
      ]) || null;

      if (isFinite(points) && isFinite(value) && value > 0) {
        candidates.push({
          ruleId: pickFirst(rule, ['redemptionRuleId','id','ruleId']) || null,
          tierName: tierOnR,
          points,
          value,
          minPoints: isFinite(minPts) ? minPts : undefined,
          maxPoints: isFinite(maxPts) ? maxPts : undefined,
          step: Math.max(1, points)
        });
      }
    }

    return candidates;
  }

  // Score a candidate for the current tier (prefer the closest eligible tier ≤ current tier).
  function scoreCandidate(c){
    if (!curTier) return 0; // no tier info; neutral score
    const t = c.tierName;
    if (!t) return 1;       // generic applies to all tiers
    const idx = tierIdx(t);
    if (idx > curIdx) return -1; // candidate requires a higher tier than the member has
    // closer to current tier is better
    return 10 + idx; // ensure positive, larger idx wins
  }

  // Build a flat list of variable-value candidates across rules
  const variableRules = list.filter(r => ['variable-value','variable_value','variable-value-reward'].includes(normType(r)));
  let candidates = [];
  for (const r of variableRules) {
    const arr = collectTierEntriesFrom(r);
    for (const c of arr) {
      candidates.push({
        ...c,
        awardVia: getAwardVia(r),
        srcRuleType: normType(r)
      });
    }
  }

  // If nothing tiered, fall back to fixed-value
  if (!candidates.length) {
    const fixed = list.filter(r => ['fixed-value','fixed_value'].includes(normType(r)));
    if (fixed.length) {
      const first = fixed[0];
      const rwd = pickFirst(first, ['reward','data.reward','rewardDefinition']) || {};
      const pts = Number(pickFirst(rwd, ['points','amount.points']) || 0);
      const val = Number(pickFirst(rwd, ['value','amount.value']) || 0.05);
      return {
        type: 'fixed-value',
        ruleId: pickFirst(first, ['redemptionRuleId','id','ruleId']) || null,
        awardVia: getAwardVia(first),
        minPointsStep: pts || 1,
        minPoints: pts || 1,
        maxPoints: pts || 1,
        // keep for consistency; UI won’t use slider math in fixed mode
        ptsPerDollar: val > 0 ? (pts / val) : 20
      };
    }
    return null;
  }

  // Pick the best candidate for the current tier
  candidates = candidates
    .map(c => ({ c, s: scoreCandidate(c) }))
    .filter(x => x.s >= 0)
    .sort((a,b) => b.s - a.s);

  const best = candidates[0]?.c || null;
  if (!best) return null;

  const ptsPerDollar = best.value > 0 ? (best.points / best.value) : 20; // float (no rounding)
  const step         = Math.max(1, Number(best.step) || Number(best.points) || 1);
  const minPts       = isFinite(best.minPoints) ? Number(best.minPoints) : step;
  const maxPts       = isFinite(best.maxPoints) ? Number(best.maxPoints) : (balance || null);

  if (_debugOn()) {
    console.groupCollapsed('[Okendo][redeem] tier match');
    console.log('memberTier:', curTier || '(none)');
    console.table([{
      ruleId: best.ruleId,
      tierName: best.tierName || '(all tiers)',
      points: best.points,
      value: best.value,
      ptsPerDollar,
      minPoints: minPts,
      maxPoints: maxPts,
      step
    }]);
    console.groupEnd();
  }

  return {
    type: 'variable-value',
    ruleId: best.ruleId,
    awardVia: best.awardVia || 'coupon',
    ptsPerDollar,           // ← tier-specific ratio
    minPointsStep: step,
    minPoints: minPts,
    maxPoints: maxPts
  };
}


  function dollarsFor(pts, ptsPerDollar) { return `$${(pts / ptsPerDollar).toFixed(2)}`; }

function buildRedeemUI(loyalty, rules = []) {
  const availablePanel = document.querySelector('[data-tabs] [data-tab-panel="available"]');
  if (!availablePanel) return;

  const balance = Math.round(loyalty?.points?.balance || 0);
  __ok_redemptionCtx = getRedemptionContext(rules, balance);

  if (!__ok_redemptionCtx || !__ok_redemptionCtx.ruleId) {
    dbg("No redemption rule available for slider UI.");
    return;
  }

  const { type, minPointsStep, minPoints, maxPoints } = __ok_redemptionCtx;
  const ptsPerDollar = __ok_redemptionCtx.ptsPerDollar || 20;

  if (type !== "variable-value") {
    availablePanel.innerHTML = `
      <div class="ok-redeem-card">
        <div class="ok-redeem-card__body">
          <h3 class="ok-redeem-title">Redeem Points</h3>
          <p class="ok-redeem-desc">Your program is configured with fixed rewards. Please select one of the denominations below at checkout.</p>
        </div>
      </div>`;
    return;
  }

  availablePanel.innerHTML = `
    <div class="ok-redeem-card">
      <div class="ok-redeem-card__head">
        <div class="ok-redeem-icon">$</div>
        <div class="ok-redeem-badge">
          <div class="ok-redeem-balance" id="ok-redeem-balance">${balance}</div>
          <div class="ok-redeem-badge-sub">points</div>
        </div>
      </div>

      <div class="ok-redeem-card__body">
        <h3 class="ok-redeem-title">Convert Your Points</h3>
        <p class="ok-redeem-desc">Redeeming your hard-earned points is easy! Apply them for a discount at checkout (order minimums may apply).</p>

        <div class="ok-redeem-row">
          <span class="ok-redeem-label">Select points to redeem:</span>
          <span class="ok-redeem-selected" id="ok-redeem-selected">0 points</span>
        </div>

        <input
          type="range"
          min="0"
          max="${Math.min(balance, maxPoints || balance)}"
          step="${minPointsStep}"
          value="0"
          id="ok-redeem-slider"
          class="ok-redeem-slider"
        />
        <div class="ok-redeem-scale">
          <span>0</span>
          <span id="ok-redeem-max">${Math.min(balance, maxPoints || balance)}</span>
        </div>

        <div class="ok-redeem-summary">
          <span>Discount amount:</span>
          <span class="ok-redeem-amount" id="ok-redeem-amount">${dollarsFor(0, ptsPerDollar)}</span>
        </div>

        <button class="btn btn--primary ok-redeem-btn" id="ok-redeem-submit" disabled>Redeem Points</button>
        <div class="ok-redeem-msg" id="ok-redeem-msg" role="status" aria-live="polite"></div>
      </div>
    </div>
  `;

  const slider      = document.getElementById("ok-redeem-slider");
  const selectedLbl = document.getElementById("ok-redeem-selected");
  const amountLbl   = document.getElementById("ok-redeem-amount");
  const submitBtn   = document.getElementById("ok-redeem-submit");
  const msg         = document.getElementById("ok-redeem-msg");
  const balanceEl   = document.getElementById("ok-redeem-balance");

  // derive the minimum redeemable points from the rule (fallback to step)
  const STEP = Math.max(1, Number(minPointsStep) || 1);
  const MIN  = Math.max(STEP, Number(minPoints) || 0); // enforce >= step

  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
  const snap  = v => clamp(Math.round(v / STEP) * STEP, 0, Number(slider.max || 0));

  function setGateMessage(pts) {
    // show clear guidance based on the rule-driven MIN
    if (balance < MIN) {
      msg.textContent = `You need at least ${MIN} points to redeem. You currently have ${balance}.`;
      return;
    }
    if (!pts || pts < MIN) {
      msg.textContent = `Move the slider to at least ${MIN} points to redeem.`;
      return;
    }
    msg.textContent = ""; // clear when eligible
  }

  function updateUI() {
    let pts = snap(Number(slider.value || 0));
    // do NOT force-jump to MIN; just gate the CTA & show guidance
    if (Number(slider.value) !== pts) slider.value = String(pts);

    selectedLbl.textContent = `${pts} points`;
    amountLbl.textContent   = dollarsFor(pts, ptsPerDollar);

    const canRedeem = balance >= MIN && pts >= MIN;
    submitBtn.disabled = !canRedeem;
    setGateMessage(pts);
  }

  try { slider.addEventListener("input", updateUI); } catch(_) {}
  try { slider.addEventListener("change", updateUI); } catch(_) {}
  updateUI();

  try {
    submitBtn.addEventListener("click", async () => {
      let pts = snap(Number(slider.value || 0));
      if (pts < MIN || balance < MIN) { // hard gate double-check
        setGateMessage(pts);
        return;
      }

      msg.textContent = "Creating your reward…";
      submitBtn.disabled = true;

      try {
        const email = getShopifyCustomerEmail();
        if (!email) throw new Error("Missing customer email");

        const val = Number((pts / ptsPerDollar).toFixed(2));
        const res = await okCreateRedemptionTransaction({
          email,
          ruleId: __ok_redemptionCtx.ruleId,
          points: pts,
          value: val
        });

        const newBal = clamp((Number(balanceEl.textContent) || 0) - pts, 0, 999999);
        balanceEl.textContent = String(newBal);
        slider.max   = String(Math.min(newBal, __ok_redemptionCtx.maxPoints || newBal));
        slider.value = "0";
        updateUI();

        if (res?.reward?.type === "coupon") {
          const redemptions = await okFetchRedemptions(email);
          renderRedeemedCoupons(redemptions);
          msg.textContent = "Reward created! Check your Redeemed Rewards tab for the code.";
        } else if (res?.reward?.type === "store-credit") {
          const amt = res?.reward?.storeCredit?.transactionAmount;
          msg.textContent = `Store credit granted: ${amt}. You can spend it at checkout.`;
        } else {
          msg.textContent = "Reward created!";
        }
      } catch (err) {
        dbge("Redeem error:", err);
        msg.textContent = "Sorry, we couldn't create your reward. Please try again.";
      } finally {
        submitBtn.disabled = false;
      }
    });
  } catch(_) {}
}


  async function okCreateRedemptionTransaction({ email, ruleId, points, value }) {
    const url = `${OKENDO_BASE}/loyalty/redemption_transactions`;
    const body = {
      customerIdentifier: { email },
      redemptionRuleId: ruleId,
      variableValue: { points: Number(points), value: Number(value) }
    };
    return fetchJson(url, { method: "POST", body: JSON.stringify(body) });
  }
  async function okFetchRedemptions(email) {
    if (!email) return [];
    const url = `${OKENDO_BASE}/loyalty/coupons?email=${encodeURIComponent(email)}`;
    const out = await fetchJson(url);
    return Array.isArray(out?.coupons) ? out.coupons : [];
  }
  function styleRedeemedPanel() {
    const panel = document.querySelector('[data-tabs] [data-tab-panel="redeemed"]');
    if (panel) panel.classList.add("ok-panel-green");
  }

  function injectCouponCopyCss() {
    if (document.getElementById("ok-coupon-copy-css")) return;
    const css = `
      .ok-activity-card__right{display:flex;align-items:center;gap:12px}
      .ok-status{font-weight:600;text-transform:lowercase}

      .ok-copy-btn{
        position:relative;display:inline-flex;align-items:center;justify-content:center;
        width:36px;height:36px;border:0;border-radius:10px;background:#0b3a2b;color:#fff;
        cursor:pointer;line-height:1;transition:transform .04s ease,opacity .2s ease
      }
      .ok-copy-btn:hover{opacity:.95}
      .ok-copy-btn:active{transform:translateY(1px)}
      .ok-copy-btn svg{width:18px;height:18px;display:block}

      /* Tooltip */
      .ok-copy-btn .ok-tooltip{
        position:absolute;left:50%;bottom:120%;transform:translateX(-50%);
        background:#0b3a2b;color:#fff;border-radius:8px;padding:4px 8px;font-size:12px;
        white-space:nowrap;opacity:0;pointer-events:none;transition:opacity .18s ease
      }
      .ok-copy-btn .ok-tooltip::after{
        content:"";position:absolute;top:100%;left:50%;transform:translateX(-50%);
        border:6px solid transparent;border-top-color:#0b3a2b;
      }
      .ok-copy-btn:hover .ok-tooltip,
      .ok-copy-btn:focus-visible .ok-tooltip,
      .ok-copy-btn.is-copied .ok-tooltip{opacity:1}

      /* Accessible (screen-reader only) label, if you keep it */
      .sr-only{position:absolute!important;width:1px;height:1px;padding:0;margin:-1px;
        overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}
    `;
    const tag = document.createElement("style");
    tag.id = "ok-coupon-copy-css";
    tag.textContent = css;
    document.head.appendChild(tag);
  }
  
  function renderRedeemedCoupons(coupons = []) {
    styleRedeemedPanel();
    injectCouponCopyCss();

    const empty = document.getElementById("okendo-coupons-empty");
    const list  = document.getElementById("okendo-coupons-list");
    if (!empty || !list) return;

    if (!coupons.length) {
      empty.style.display = "";
      list.style.display = "none";
      list.innerHTML = "";
      return;
    }

    empty.style.display = "none";
    list.style.display = "";
    list.classList.remove("grid--4-col");
    list.classList.add("grid");
    list.style.gridTemplateColumns = "1fr";

    list.innerHTML = coupons.map(c => {
      const code        = c.code || "—";
      const description = c.description || "Discount";
      const value       = (c.value != null ? `$${Number(c.value).toFixed(2)}` : "");
      const status      = (c.status || "active").toString().toLowerCase();

      return `
        <div class="grid__item">
          <div class="ok-activity-card">
            <div class="ok-activity-card__inner">
              <div class="ok-activity-card__left">
                <div class="ok-activity-card__title">${description}</div>
                <div class="ok-activity-card__date">Code: <span class="ok-coupon-code">${code}</span></div>
                <div class="ok-activity-card__date">Discount: ${value}</div>
              </div>
              <div class="ok-activity-card__right">
                <div class="ok-status">${status}</div>
                <button class="ok-copy-btn" data-code="${code}" aria-label="Copy coupon code">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                  <span class="ok-tooltip" role="tooltip">Copy your code</span>
                  <span class="sr-only">Copy</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join("");

    list.querySelectorAll(".ok-copy-btn").forEach(btn => {
      try { btn.addEventListener("click", async () => {
        const code = btn.getAttribute("data-code") || "";
        const ok = await copyToClipboard(code);
        const tip = btn.querySelector(".ok-tooltip");
        btn.classList.add("is-copied");
        if (tip) {
          const prev = tip.textContent;
          tip.textContent = ok ? "Copied!" : "Press ⌘/Ctrl+C";
          setTimeout(() => {
            tip.textContent = prev || "Copy";
            btn.classList.remove("is-copied");
          }, 1400);
        }
      }); } catch(_) {}
    });
  }


  /* ====== API + data load ====== */
  async function loadOkendoData() {
    if (!hasOkendoCreds()) return;

    const custEmail = getShopifyCustomerEmail();
    dbg("loadOkendoData: Shopify customer email →", custEmail || "(none)");
    ensureLoginButtonVisibility();

    if (!custEmail) {
      applyVisibility("non-member", { onlyGated: true });
      ensureReferHero(false);
      return;
    }

    let loyalty = null;
    try {
      const resp = await fetchJson(`${OKENDO_BASE}/loyalty/customers?email=${encodeURIComponent(custEmail)}`);
      loyalty = resp?.loyaltyCustomer || null;
      if (loyalty) {
        __ok_vipTierName    = loyalty.vipTierName || null;
        __ok_minVipTierName = loyalty.minimumVipTierName || null;
        if (_debugOn()){
          console.groupCollapsed('[Okendo][loyalty] raw');
          try { console.log(JSON.parse(JSON.stringify(loyalty))); } catch { console.dir(loyalty); }
          console.log('vipTierName:', __ok_vipTierName, 'minimumVipTierName:', __ok_minVipTierName, 'points.balance:', loyalty?.points?.balance);
          console.groupEnd();
        }
      }
    } catch (err) {
      if (!isNotFoundError(err)) dbge("API error (customers):", err);
    }

    if (loyalty) {
      // NEW: resolve YTD spend (profiles → proxy). OK if null; UI will fall back.
      __ok_ytdSpend = await resolveYTDSpend(custEmail);
      if (_debugOn()) dbg('YTD spend resolved →', __ok_ytdSpend);

      applyVisibility("member", { onlyGated: true });
      enhanceProfileCards();
      renderMemberOverview(loyalty);   // will pick up __ok_ytdSpend below
      renderMiniTier(loyalty);         // now shows spend-based progress when available

      const bal = Math.round(loyalty.points?.balance ?? 0);
      setText("#okendo-points", String(bal));
      setText("#okendo-tier", __ok_vipTierName || "Bronze Wing");

      updateTierUI();                  // updated to use spend when available

      ensureReferHero(true);
      loadReferralShare(custEmail);
    } else {
      applyVisibility("non-member", { onlyGated: true });
      ensureReferHero(false);
    }

    try {
      const redemptionRules = await fetchRedemptionRulesRobust(custEmail);
      logRedemptionRules(redemptionRules);
      if (loyalty && redemptionRules.length) buildRedeemUI(loyalty, redemptionRules);
      const coupons = await okFetchRedemptions(custEmail);
      renderRedeemedCoupons(coupons);
    } catch (err) {
      if (!isNotFoundError(err)) dbge("API error (redemption rules / coupons):", err);
      styleRedeemedPanel();
    }

    initWaysToEarn({ customerEmail: custEmail, isMember: !!loyalty });
  }



  /* =========================
     Point History / Activities
     ========================= */
  let __ok_historyLoaded = false;

  async function okLookupCustomerIdByEmail(email) {
    if (!email) return null;
    dbg("Lookup customerId for", email);
    const out = await fetchJson(`${OKENDO_BASE}/customer_lookup`, {
      method: "POST",
      body: JSON.stringify({ email })
    });
    const id = out?.customerId || null;
    dbg("Lookup result customerId:", id);
    return id;
  }
  window.okLookupCustomerIdByEmail = okLookupCustomerIdByEmail;


  // Try multiple namespaces – some tenants store everything at the root.
  const EARNING_NS_GUESSES = ["loyalty", "loyalty:earning", "earning", "rewards", "reward", "", null];

  // chooses proxy (if set) or direct Okendo
  async function fetchActivitiesPage(customerId, { namespace = "", limit = 100 } = {}) {
    if (OKENDO_ACTIVITIES_PROXY) {
      const u = new URL(OKENDO_ACTIVITIES_PROXY, location.origin);
      u.searchParams.set("customerId", customerId);
      u.searchParams.set("limit", String(limit));
      if (namespace) u.searchParams.set("namespace", namespace);
      return fetchJson(u.toString(), { noAuth: true }); // proxy is same-origin; avoid extra headers
    } else {
      const u = new URL(`${OKENDO_BASE}/customers/${customerId}/activities`);
      u.searchParams.set("limit", String(limit));
      if (namespace) u.searchParams.set("namespace", namespace);
      return fetchJson(u.toString());
    }
  }

  async function okFetchActivities(customerId, { namespace = "loyalty", limit = 100 } = {}) {
    if (!customerId) return [];
    const all = [];
    let url = null;
    let page = null;

    // first page
    page = await fetchActivitiesPage(customerId, { namespace, limit });
    const items = Array.isArray(page?.activities) ? page.activities : [];
    all.push(...items);
    url = page?.nextUrl ? (new URL(page.nextUrl, OKENDO_BASE)).toString() : null;

    // follow nextUrl only for direct calls (proxy typically flattens paging)
    let safety = 4;
    while (url && !OKENDO_ACTIVITIES_PROXY && safety-- > 0) {
      const res = await fetchJson(url);
      const rows = Array.isArray(res?.activities) ? res.activities : [];
      all.push(...rows);
      url = res?.nextUrl ? (new URL(res.nextUrl, OKENDO_BASE)).toString() : null;
    }
    return all;
  }

  async function okFetchActivitiesMulti(customerId, limit = 200) {
    const seen = new Set();
    const out = [];
    for (const ns of EARNING_NS_GUESSES) {
      try {
        const list = await okFetchActivities(customerId, { namespace: ns || "", limit });
        for (const a of list) {
          const key = JSON.stringify([a?.id, a?.createdAt, a?.title, a?.namespace]);
          if (!seen.has(key)) { seen.add(key); out.push(a); }
        }
        if (_debugOn()) console.log(`[Okendo][activities] ns="${ns ?? ''}" → ${list.length}`);
      } catch (e) {
        // swallow CORS / 401 / misc errors and keep going
        dbgw(`[Okendo][activities] ns="${ns ?? ''}" failed:`, e?.message || e);
      }
    }
    return out;
  }

  function getPointsDelta(a) {
    const cands = [
      a.pointsDelta, a.pointsChange, a.delta, a.deltaPoints,
      a.points?.delta, a.points?.change, a.points?.amount,
      a.metadata?.points, a.properties?.points, a.data?.points,
      a.reward?.points
    ];
    let d = cands.find(v => typeof v === "number" && isFinite(v));
    if (d == null) {
      const s = cands.find(v => typeof v === "string" && v.trim() && !isNaN(Number(v)));
      if (s != null) d = Number(s);
    }
    if (d == null && typeof a.title === "string") {
      const m = a.title.match(/([+-]?\d+)\s*points?/i);
      if (m) d = Number(m[1]);
    }
    return (typeof d === "number" && isFinite(d)) ? d : null;
  }

  function isCustomerFacingActivity(a) {
    const t  = (a.title || "").toLowerCase();
    if (/(email sent|notification|digest)/.test(t)) return false;
    if (/(status changed)/.test(t)) return false;
    return true;
  }

  /* ---- Redemption rules helpers & logger ---- */
async function okAwardByActionSlug(email, action, actionCategory){
  const attempts = [
    // modern (likely) body
    { url: `${OKENDO_BASE}/loyalty/earning_transactions`, body: { action, actionCategory, customerIdentifier: { email } } },
    // fallback bodies some tenants accept
    { url: `${OKENDO_BASE}/loyalty/earning_transactions`, body: { action, customerIdentifier: { email } } },
    { url: `${OKENDO_BASE}/loyalty/earning_transactions/by_action`, body: { action, actionCategory, customerIdentifier: { email } } }
  ];

  let lastErr;
  for (const a of attempts) {
    try {
      return await fetchJson(a.url, { method: 'POST', body: JSON.stringify(a.body) });
    } catch (e) {
      lastErr = e;
      // quietly try the next variant unless it's a hard 401/403
      const msg = String(e?.message || '');
      if (msg.includes(' 401 ') || msg.includes(' 403 ')) break;
    }
  }
  throw lastErr || new Error('Unable to award by action');
}


function normalizeRuleType(t){
  return String(t||'').toLowerCase().replace(/[\s_]+/g,'-');
}
function pluckRules(payload){
  if (!payload) return [];
  if (Array.isArray(payload.rules)) return payload.rules;
  if (Array.isArray(payload.redemptionRules)) return payload.redemptionRules;
  if (Array.isArray(payload.data?.rules)) return payload.data.rules;
  if (Array.isArray(payload.data?.redemptionRules)) return payload.data.redemptionRules;
  return [];
}
function summarizeRedemptionRule(r){
  const type      = normalizeRuleType(pickFirst(r,['type','rule.type','reward.type']));
  const reward    = pickFirst(r, ['reward','data.reward','rewardDefinition']) || {};
  const id        = pickFirst(r, ['redemptionRuleId','id','ruleId']);
  const title     = pickFirst(r, ['title','name','displayName','rule.title']);
  const points    = pickFirst(reward, ['points','amount.points']);
  const value     = pickFirst(reward, ['value','amount.value']);
  const minPoints = pickFirst(reward, ['minimumPoints']);
  const maxPoints = pickFirst(reward, ['maximumPoints']);
  const awardVia  = pickFirst(reward, ['awardVia','award_via']);
  return { id, type, title, points, value, minPoints, maxPoints, awardVia };
}
function logRedemptionRules(rules){
  const list = Array.isArray(rules) ? rules : [];
  console.groupCollapsed(`[Okendo][redeem] rules (${list.length})`);
  try { console.table(list.map(summarizeRedemptionRule)); } catch(_){ console.log(list); }
  console.groupCollapsed('[Okendo][redeem] raw sample');
  try { console.log(JSON.parse(JSON.stringify(list.slice(0,5)))); } catch { console.dir(list.slice(0,5)); }
  console.groupEnd(); console.groupEnd();
}
function uniqBy(arr, keyFn){
  const seen=new Set(), out=[];
  for (const x of (arr||[])){ const k=keyFn(x); if(!seen.has(k)){ seen.add(k); out.push(x); } }
  return out;
}
/* Try multiple shapes/paths; stop on first non-empty */
async function fetchRedemptionRulesRobust(email){
  const enc = encodeURIComponent(email || '');
  const attempts = [
    `${OKENDO_BASE}/loyalty/redemption_rules?email=${enc}`,
    `${OKENDO_BASE}/loyalty/redemption_rules`,
    `${OKENDO_BASE}/loyalty/reward_rules?email=${enc}`,
    `${OKENDO_BASE}/loyalty/reward_rules`,
    `https://api.okendo.io/v1/loyalty/redemption_rules?email=${enc}`,
    `https://api.okendo.io/v1/loyalty/redemption_rules`,
  ];
  const all = [];
  for (const url of attempts){
    try{
      const res = await fetchJson(url);
      const rules = pluckRules(res);
      dbg('[redeem] attempt', url, '→', Array.isArray(rules)?rules.length:0);
      all.push(...(rules||[]));
      if (rules && rules.length) break; // take first non-empty
    }catch(e){
      dbgw('[redeem] attempt failed:', url, e?.message || e);
    }
  }
  return uniqBy(all, r => JSON.stringify([
    pickFirst(r,['redemptionRuleId','id','ruleId']) || null,
    pickFirst(r,['title','name','displayName']) || null,
    normalizeRuleType(pickFirst(r,['type','rule.type','reward.type']))
  ]));
}


  // ===== Activities debug logger
  function actionIdFromActivity(a){
    const cands = [
      a?.actionId, a?.sourceActionId, a?.ruleActionId,
      a?.action?.id, a?.action?.actionId, a?.rule?.actionId,
      a?.metadata?.actionId, a?.properties?.actionId, a?.data?.actionId
    ];
    const s = cands.find(v => typeof v === 'string' && v.trim());
    return s ? s.trim() : null;
  }
  function ruleIdFromActivity(a){
    const cands = [a?.earningRuleId, a?.ruleId, a?.rule?.id, a?.data?.ruleId];
    const s = cands.find(v => typeof v === 'string' && v.trim());
    return s ? s.trim() : null;
  }
  function logActivities(acts){
    const safe = Array.isArray(acts) ? acts : [];
    const rows = safe.map(a => ({
      date: fmtDate(a.createdAt || a.date || a.created_at),
      title: a.title || a.name || '(activity)',
      namespace: a.namespace || '—',
      actionId: actionIdFromActivity(a) || '—',
      ruleId: ruleIdFromActivity(a) || '—',
      delta: getPointsDelta(a) ?? '—'
    }));
    console.groupCollapsed(`[Okendo][activities] ${rows.length} items`);
    try { console.table(rows); } catch(_) {}
    if (safe.length) {
      console.groupCollapsed('[Okendo][activities] raw sample');
      try { console.log(JSON.parse(JSON.stringify(safe.slice(0, 5)))); } catch { console.dir(safe.slice(0, 5)); }
      console.groupEnd();
    }
    console.groupEnd();
  }

  function renderPointHistory(activities) {
    const empty = document.getElementById("okendo-history-empty");
    const list  = document.getElementById("okendo-history-list");
    if (!empty || !list) { console.error("[Okendo] History containers not found"); return; }

    const visible = (activities || []).filter(isCustomerFacingActivity);

    const rows = visible.map(a => {
      const date = a.date || a.createdAt || a.created_at;
      const title = (() => {
        const raw = a.title || "Activity";
        const key = raw.toLowerCase();
        if (key.includes("order placed")) return "Order Placed";
        if (key.includes("earned loyalty points")) return "Earned Loyalty Points";
        if (key.includes("redeem")) return "Redeemed Points";
        return raw;
      })();
      const delta = getPointsDelta(a);
      return { date, title, delta };
    });

    if (!rows.length) {
      empty.style.display = "";
      list.style.display  = "none";
      list.innerHTML = "";
      return;
    }

    empty.style.display = "none";
    list.style.display  = "";

    list.innerHTML = rows.slice(0, 50).map(({ date, title, delta }) => {
      const dateStr   = fmtDate(date);
      const sign      = delta > 0 ? "+" : "";
      const pointsStr = (delta == null ? "" : `${sign}${delta} pts`);
      const posNegCls = (delta == null) ? "" : (delta > 0 ? "is-pos" : (delta < 0 ? "is-neg" : ""));

      return `
        <div class="grid__item">
          <div class="ok-activity-card">
            <div class="ok-activity-card__inner">
              <div class="ok-activity-card__left">
                <div class="ok-activity-card__title">${title}</div>
                <div class="ok-activity-card__date">${dateStr}</div>
              </div>
              <div class="ok-activity-card__points ${posNegCls}">${pointsStr}</div>
            </div>
          </div>
        </div>
      `;
    }).join("");
  }

  async function loadPointHistoryIfNeeded() {
    dbg("loadPointHistoryIfNeeded start");
    if (__ok_historyLoaded) { dbg("history already loaded"); return; }
    if (!hasOkendoCreds()) return;

    const email = getShopifyCustomerEmail();
    if (!email) { dbgw("No customer email; history not loaded."); return; }

    try {
      const customerId = await okLookupCustomerIdByEmail(email);
      if (!customerId) {
        dbgw("No customerId from lookup; rendering empty history.");
        renderPointHistory([]);
        __ok_historyLoaded = true;
        return;
      }

      const acts = await okFetchActivitiesMulti(customerId, 200);
      logActivities(acts);
      renderPointHistory(acts);
      __ok_historyLoaded = true;
      dbg("loadPointHistoryIfNeeded ✓ done");
    } catch (err) {
      dbge("history error:", err);
      renderPointHistory([]);
      __ok_historyLoaded = true;
    }
  }

  /* ===== REFER A FRIEND (Member-only hero + share link) ===== */
  function injectReferHeroCSS() {
    if (document.getElementById("ok-refer-hero-css")) return;
    const css = `
      .ok-refer-hero{position:relative;border-radius:12px;padding:32px 24px;overflow:hidden;margin:16px 0;}
      .ok-refer-hero__bg{position:absolute;inset:0;background:linear-gradient(90deg,#07391f 0%,#133b1f 50%,#1e3e1f 100%);opacity:.95;}
      .ok-refer-hero__inner{position:relative;z-index:1;text-align:center;color:#f7f8f6;}
      .ok-refer-hero__title{font-weight:800;line-height:1.2;margin:0 0 10px;font-size:28px;}
      .ok-refer-hero__desc{opacity:.92;margin:0 auto 18px;max-width:720px;}
      .ok-refer-hero__row{display:flex;gap:12px;justify-content:center;max-width:640px;margin:0 auto;}
      .ok-refer-hero__input{flex:1;min-width:260px;height:44px;border-radius:8px;border:1px solid rgba(255,255,255,.35);background:rgba(255,255,255,.08);color:#fff;padding:0 12px;outline:none;}
      .ok-refer-hero__input::placeholder{color:rgba(255,255,255,.7)}
      .ok-refer-hero__btn{display:inline-flex;align-items:center;gap:8px;border:0;height:46px;border-radius:8px;padding:0 18px;background:#e7d7b0;color:#0b2c14;font-weight:600;cursor:pointer;}
      .ok-refer-hero__btn:hover{filter:brightness(.96)}
      .ok-hidden{display:none !important;}
      .ok-refer-share{margin-top:22px;}
      .ok-refer-share__title{margin:8px 0 10px;font-weight:700;font-size:22px;color:#f7f8f6;}
      .ok-refer-share__group{display:flex;gap:12px;justify-content:center;max-width:640px;margin:0 auto;}
      .ok-refer-share__input{background:rgba(255,255,255,.12);}
      .ok-refer-share__copy{min-width:110px;}
      .ok-refer-share__msg{margin-top:8px;font-size:.95rem;opacity:.9}
    `;
    const tag = document.createElement("style");
    tag.id = "ok-refer-hero-css";
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function ensureReferHero(isMember){
    if (OKENDO_EMBED_REFERRAL) return; // using the embedded app; do nothing
    // ...keep your old fallback hero logic if you still want it elsewhere
  }

  /*
  function ensureReferHero(isMember) {
    if (OKENDO_EMBED_REFERRAL) return; 
    const legacy = document.querySelector(".refer-banner, .referral-banner, [data-refer-banner], #refer-banner");
    let hero = document.getElementById("ok-refer-hero");

    if (isMember) {
      injectReferHeroCSS();
      if (legacy) legacy.classList.add("ok-hidden");

      if (!hero) {
        hero = document.createElement("div");
        hero.id = "ok-refer-hero";
        hero.className = "ok-refer-hero";
        hero.innerHTML = `
          <div class="ok-refer-hero__bg"></div>
          <div class="ok-refer-hero__inner">
            <h3 class="ok-refer-hero__title">Give $20, Get $20</h3>
            <p class="ok-refer-hero__desc">
              Give your friends $20 off on their first order of $99+ and get $20 (in points) for each successful referral
            </p>
            <div class="ok-refer-hero__row">
              <input type="email" class="ok-refer-hero__input" placeholder="Enter friend's email address" />
              <button class="ok-refer-hero__btn" type="button" aria-label="Send referral">
                <span>Send</span>
              </button>
            </div>

            <div class="ok-refer-share" id="ok-refer-share" hidden>
              <h4 class="ok-refer-share__title">Share Your Referral Link</h4>
              <div class="ok-refer-share__group">
                <input type="text" readonly class="ok-refer-hero__input ok-refer-share__input" id="ok-refer-link" value="" />
                <button class="ok-refer-hero__btn ok-refer-share__copy" id="ok-refer-copy" type="button" aria-label="Copy referral link">
                  <span>Copy</span>
                </button>
              </div>
              <div class="ok-refer-share__msg" id="ok-refer-copy-msg" aria-live="polite"></div>
            </div>
          </div>
        `;
        if (legacy && legacy.parentNode) {
          legacy.insertAdjacentElement("afterend", hero);
        } else {
          const parent = document.querySelector('.okendo-loyalty-root, #okendo-loyalty-root') || document.body;
          parent.appendChild(hero);
        }
      }
    } else {
      if (hero && hero.parentNode) hero.parentNode.removeChild(hero);
      if (legacy) legacy.classList.remove("ok-hidden");
    }
  }*/

  async function okFetchReferralLink(email) {
    if (!email) return null;

    let customerId = null;
    try {
      const lookup = await fetchJson(`${OKENDO_BASE}/customer_lookup`, {
        method: "POST",
        body: JSON.stringify({ email })
      });
      customerId = lookup?.customerId || null;
    } catch (e) {
      if (!isNotFoundError(e)) dbgw("customer_lookup failed:", e?.message || e);
    }
    if (!customerId) return null;

    const namespaces = ["referral", "referrals", "loyalty-referral", "loyalty:referral", ""];
    const urlForNS = (ns) =>
      ns
        ? `${OKENDO_BASE}/customers/${customerId}/profiles?namespace=${encodeURIComponent(ns)}`
        : `${OKENDO_BASE}/customers/${customerId}/profiles`;

    const looksLikeUrl = (s) => typeof s === "string" && /^https?:\/\/\S+$/i.test(s.trim());
    const isReferralishName = (name = "", ns = "") =>
      /(referr|share|invite|link|url)/i.test(name) || /(referr|share|invite)/i.test(ns);
    const isOkendoShort = (s = "") => /oken\.do|okendo\.link|okendo\.io\/r\//i.test(s);

    for (const ns of namespaces) {
      try {
        const res = await fetchJson(urlForNS(ns));
        const profiles = Array.isArray(res?.profiles) ? res.profiles : [];
        for (const prof of profiles) {
          const nsName = prof?.namespace || "";
          const props = Array.isArray(prof?.properties) ? prof.properties : [];
          for (const prop of props) {
            const name = prop?.name || "";
            const val = prop?.value;
            if (typeof val === "string") {
              if ((isReferralishName(name, nsName) && looksLikeUrl(val)) || isOkendoShort(val)) {
                dbg("Referral link found in profiles:", { ns: nsName, name });
                return val.trim();
              }
            }
          }
        }
      } catch (e) {
        if (!isNotFoundError(e)) dbgw("profiles fetch failed:", ns || "(all)", e?.message || e);
      }
    }
    return null;
  }

  async function loadReferralShare(email) {
    const wrap = document.getElementById("ok-refer-share");
    const input = document.getElementById("ok-refer-link");
    const copyBtn = document.getElementById("ok-refer-copy");
    const msg = document.getElementById("ok-refer-copy-msg");
    if (!wrap || !input || !copyBtn) return;

    wrap.hidden = true;
    input.value = "Loading…";

    try {
      const link = await okFetchReferralLink(email);
      if (link) {
        input.value = link;
        wrap.hidden = false;
        try { input.addEventListener("focus", () => input.select()); } catch(_) {}
        copyBtn.onclick = async () => {
          const ok = await copyToClipboard(link);
          if (msg) {
            msg.textContent = ok ? "Copied!" : "Copy failed — press ⌘/Ctrl+C";
            setTimeout(() => (msg.textContent = ""), 1400);
          }
        };
      } else {
        wrap.hidden = true;
      }
    } catch (e) {
      dbgw("Referral link load error:", e?.message || e);
      wrap.hidden = true;
    }
  }

  /* =========================
     Ways to Earn
     ========================= */

  // match Okendo rule titles to your data-earn values
  const RULE_TITLE_TO_KEY = {
    'Join Program': 'join_program',
    'Celebrate A Birthday': 'birthday',
    'Celebrate An Anniversary': 'anniversary',
    'Like On Facebook': 'facebook_like',
    'Follow On Instagram': 'instagram_follow',
    'Refer A Friend': 'refer_friend',
    'Place An Order': 'place_order',
    'Write A Review': 'write_review'
  };

  function toast(msg){ if (_debugOn()) console.log("[Okendo][toast]", msg); }

  // --- schema-agnostic getters for unknown API shapes ---
  function deepGet(obj, path) {
    if (!obj || !path) return undefined;
    const parts = path.split('.');
    let cur = obj;
    for (const p of parts) {
      if (cur == null) return undefined;
      cur = cur[p];
    }
    return cur;
  }
  function pickFirst(obj, paths) {
    for (const p of paths) {
      const val = deepGet(obj, p);
      if (val !== undefined && val !== null && String(val).trim() !== '') return val;
    }
    return undefined;
  }
  function short(str, n = 120) {
    if (typeof str !== 'string') return '';
    return str.length > n ? (str.slice(0, n - 1) + '…') : str;
  }
  function summarizeRule(r) {
    const title = pickFirst(r, [
      'title', 'name', 'displayName', 'label',
      'rule.title', 'rule.name', 'rule.displayName'
    ]) || '';

    const type = pickFirst(r, [
      'type', 'ruleType', 'earningType', 'action.type',
      'rule.type', 'reward.type'
    ]) || '';

    // New: Okendo tenants that return action slugs instead of IDs
    const actionSlug = pickFirst(r, ['action', 'rule.action', 'data.action']) || null;
    const actionCategory = pickFirst(r, ['actionCategory', 'rule.actionCategory', 'data.actionCategory']) || null;

    // Keep (real) actionId if present on some tenants
    const actionId = pickFirst(r, [
      'actionId', 'action.actionId', 'action.id',
      'rule.actionId', 'rule.action.id',
      'earningAction.actionId', 'earningAction.id',
      'actionDefinition.actionId', 'actionDefinition.id',
      'definition.actionId', 'definition.id'
    ]) || null;

    const ruleId = pickFirst(r, ['id', 'ruleId', 'earningRuleId']) || null;

    const points = pickFirst(r, [
      'reward.points', 'rewardDefinition.points',
      'points', 'amount.points', 'reward.amount.points',
      'reward.amount', 'reward.amountForReview' // some shapes
    ]);
    const value = pickFirst(r, [
      'reward.value', 'rewardDefinition.value',
      'value', 'amount.value', 'reward.amount.value'
    ]);

    const description = pickFirst(r, [
      'description', 'details.description', 'metadata.description',
      'copy', 'text', 'body', 'summary', 'content'
    ]) || '';

    const active   = pickFirst(r, ['active', 'isActive']);
    const startsAt = pickFirst(r, ['startsAt', 'startAt', 'start']);
    const endsAt   = pickFirst(r, ['endsAt', 'endAt', 'end']);

    return { title, type, actionId, actionSlug, actionCategory, ruleId, points, value, description, active, startsAt, endsAt };
  }

  // Map rule titles to your tile keys (fuzzy, case-insensitive)
  const TITLE_KEYWORDS = [
    { key: 'join_program',     tests: [/join/i, /sign\s*up/i] },
    { key: 'birthday',         tests: [/birthday/i] },
    { key: 'anniversary',      tests: [/anniversary/i] },
    { key: 'facebook_like',    tests: [/facebook/i, /like/i] },
    { key: 'instagram_follow', tests: [/instagram/i, /follow/i] },
    { key: 'refer_friend',     tests: [/refer/i, /referral/i, /invite/i] },
    { key: 'place_order',      tests: [/order/i, /purchase/i, /spend/i] },
    { key: 'write_review',     tests: [/review/i, /feedback/i] },
  ];
  function keyFromTitle(title) {
    const t = String(title || '').toLowerCase();
    for (const row of TITLE_KEYWORDS) {
      if (row.tests.every(rx => rx.test(t))) return row.key;
    }
    for (const row of TITLE_KEYWORDS) {
      if (row.tests.some(rx => rx.test(t))) return row.key;
    }
    return null;
  }

  // ===== Build completion sets from Activities =====
  async function buildCompletionSets(email, rules) {
    const completedByActionId = new Set();
    const completedByKey = new Set();
    let completedByAction = new Set(); // <— NEW

    try {
      // 1) look up customerId
      const { customerId } = await okLookupCustomerIdByEmail(email);
      if (!customerId) return { completedByActionId, completedByKey, completedByAction };

      // 2) pull activities (same as you had)
      const namespaces = ['', 'loyalty', 'loyalty:earning', 'earning', 'rewards', 'reward'];
      const acts = await okFetchActivitiesMulti(customerId, namespaces, 200);

      // index by title-ish and pull any actionIds we already know about
      for (const a of acts) {
        const title = nrm(a?.title);
        if (!title) continue;

        // heuristic title→tile key matches
        if (/\bjoin\b/.test(title) && /\b(program|account|enroll)\b/.test(title)) completedByKey.add('join_program');
        if (/\bbirthday\b/.test(title)) completedByKey.add('birthday');
        if (/\brefer\b/.test(title)) completedByKey.add('refer_friend');
        if (/\breview\b/.test(title)) completedByKey.add('write_review');
        if (/\b(ugc|photo|image|video)\b/.test(title)) completedByKey.add('review_ugc');
        if (/\bfacebook\b/.test(title)) completedByKey.add('facebook_like');
        if (/\binstagram\b/.test(title)) completedByKey.add('instagram_follow');
        if (/\btik[\s-]?tok\b/.test(title)) completedByKey.add('tiktok_follow');
      }

      // 3) pull profiles ONCE (no namespace) and detect social completions
      const profRes = await fetchJson(`${OKENDO_BASE}/customers/${customerId}/profiles`);
      const profiles = Array.isArray(profRes?.profiles) ? profRes.profiles : [];
      completedByAction = detectSocialCompletionsFromProfiles(profiles);

      console.groupCollapsed('[Okendo][earn] completion sets');
      console.log('byKey  →', [...completedByKey]);
      console.log('byAct  →', [...completedByAction]);
      console.groupEnd();

    } catch (e) {
      dbgw('[Okendo][earn] completion scan failed:', e?.message || e);
    }

    return { completedByActionId, completedByKey, completedByAction };
  }


  function typeToKey(type, title){
  const t = (normalizeRuleType(type) + ' ' + String(title||'').toLowerCase());
  if (/birthday/.test(t)) return 'birthday';
  if (/instagram/.test(t)) return 'instagram_follow';
  if (/facebook/.test(t))  return 'facebook_like';
  if (/tiktok/.test(t))    return 'tiktok_follow';
  if (/(review).*(photo|image|ugc)|(photo|image|ugc).*(review)/.test(t)) return 'review_ugc';
  if (/(review|feedback)/.test(t)) return 'write_review';
  if (/(refer|referral|invite)/.test(t)) return 'refer_friend';
  if (/(order|purchase|spend)/.test(t))  return 'place_order';
  if (/(join|sign\s*up|create.*account)/.test(t)) return 'join_program';
  return null;
}

  function mapRulesAndInjectIdsOrActions(rules){
    const mapped = [];
    for (const r of (rules || [])) {
      const s = summarizeRule(r);

      // 1) Primary mapping by action slug
      let tileKey = ACTION_TO_TILE[s.actionSlug] || null;

      // 2) Fallbacks (keeps your previous heuristics)
      if (!tileKey) tileKey = RULE_TITLE_TO_KEY[s.title || ''] || keyFromTitle(s.title) || typeToKey(s.type, s.title);

      if (!tileKey) continue;

      // Stamp attributes onto the matched tile buttons
      document.querySelectorAll(`[data-earn-btn][data-earn="${tileKey}"]`).forEach(btn => {
        // Prefer true actionId if tenant provides one
        if (s.actionId && !btn.dataset.actionId) {
          btn.dataset.actionId = s.actionId;
        }
        // Otherwise fall back to action slug + category (what your JSON shows)
        if (!btn.dataset.actionId && s.actionSlug) {
          btn.dataset.okAction = s.actionSlug;
          if (s.actionCategory) btn.dataset.okActionCategory = s.actionCategory;
          mapped.push({ key: tileKey, action: s.actionSlug, category: s.actionCategory || null });
        }
      });

      // Special case: review UGC tile — reuse submit-review action if present
      if (s.actionSlug === 'submit-review') {
        document.querySelectorAll(`[data-earn-btn][data-earn="review_ugc"]`).forEach(btn => {
          if (!btn.dataset.actionId && !btn.dataset.okAction) {
            btn.dataset.okAction = s.actionSlug;
            if (s.actionCategory) btn.dataset.okActionCategory = s.actionCategory;
            mapped.push({ key: 'review_ugc', action: s.actionSlug, category: s.actionCategory || null });
          }
        });
      }
    }

    if (_debugOn()) {
      console.groupCollapsed('[Okendo][earn] mapped tile → action (auto)');
      try { console.table(mapped); } catch(_) { console.log(mapped); }
      console.groupEnd();
    }
  }

  async function initWaysToEarn(state) {
    if (__ok_waysWired) { dbg('initWaysToEarn: already wired'); return; }

    const email    = state?.customerEmail;
    const isMember = !!state?.isMember;
    if (!email || !hasOkendoCreds()) return;

    // ⬇️ NEW: if we’re using the Okendo app embed (no custom tiles), skip entirely
    const hasCustomTiles = !!document.querySelector('[data-earn-tile]');
    if (!hasCustomTiles) {
      __ok_waysWired = true;
      dbg('initWaysToEarn: no custom earn tiles present — using app embed; skipping');
      return;
    }

    // Helpers
    const lower  = v => (v ?? '').toString().trim().toLowerCase();
    const actKey = (a, c) => `${lower(a)}|${lower(c)}`;

    // UI key → expected Okendo action/actionCategory
    const KEY_TO_ACTION = {
      join_program:     'sign-up',
      place_order:      'purchase',
      write_review:     'submit-review',
      review_ugc:       'submit-review',
      birthday:         'birthday',
      anniversary:      'anniversary',
      facebook_like:    'facebook-like',
      instagram_follow: 'instagram-follow',
      tiktok_follow:    'tiktok-follow'
    };
    const KEY_TO_CATEGORY = {
      join_program:     'account',
      place_order:      'order',
      write_review:     'review',
      review_ugc:       'review',
      birthday:         'account',
      anniversary:      'account',
      facebook_like:    'social',
      instagram_follow: 'social',
      tiktok_follow:    'social',
      refer_friend:     'referral'
    };

    // 1) Earning rules (for action fallbacks etc.)
    let rules = [];
    try {
      const res = await fetchJson(`${OKENDO_BASE}/loyalty/earning_rules?email=${encodeURIComponent(email)}`);
      rules = Array.isArray(res?.rules) ? res.rules : [];
    } catch(_) {}
    (function logEarningRules(safeRules) {
      const rows = (safeRules || []).map(summarizeRule);
      console.groupCollapsed(`[Okendo][earn] ${rows.length} earning rules returned`);
      try {
        console.table(rows.map(r => ({
          title: r.title || '(untitled)',
          type:  r.type  || '—',
          action: r.action || '—',
          actionCategory: r.actionCategory || '—',
          actionId: r.actionId || '—',
          points: r.points ?? '—',
          value:  r.value  ?? '—',
          active: r.active ?? true,
          description: short(r.description, 100)
        })));
      } catch(_){}
      console.groupEnd();
    })(rules);

    try { mapRulesToTilesAndInjectActionIds(rules); } catch(_){}
    try { mapRulesAndInjectIdsOrActions(rules); }   catch(_){}

    // 2) Lookup maps
    const byKey = {}, byAction = {}, byActionCat = {}, byActionId = {};
    for (const r of rules) {
      const s = summarizeRule(r) || {};
      const action   = s.action ?? r.action;
      const category = s.actionCategory ?? r.actionCategory;
      const actionId = s.actionId ?? r.actionId;
      if (action) byAction[lower(action)] = r;
      if (action && category) byActionCat[actKey(action, category)] = r;
      if (actionId) byActionId[actionId] = r;
      const k = s.title ? keyFromTitle(s.title) : null;
      if (k) byKey[k] = r;
    }

    // ---------- 3) COMPLETIONS FROM ACTIVITIES (raw + tolerant) ----------
    async function buildCompletionsFromActivities(email) {
      const empty = { completedByActionId: [], completedByKey: [], completedByAction: [], completedByActionCat: [] };

      // 3a) find customerId (may fail due to CORS)
      let customerId = state?.customerId;
      try {
        if (!customerId) {
          const res = await fetchJson(`${OKENDO_BASE}/customer_lookup`, {
            method: 'POST',
            body: JSON.stringify({ email })
          });
          customerId = res?.customerId || null;
        }
      } catch (e) {
        dbgw('[Okendo][earn] customer_lookup failed (will use cache if any):', e?.message || e);
      }
      if (!customerId) {
        // last known cache?
        try {
          const cached = JSON.parse(sessionStorage.getItem(`ok-acts:${email}`) || 'null');
          return cached || empty;
        } catch { return empty; }
      }

      // 3b) pull recent activities WITHOUT namespace filter (social/account items can vary)
      let activities = [];
      try {
        const res = await fetchJson(`${OKENDO_BASE}/customers/${customerId}/activities?limit=200`);
        activities = Array.isArray(res?.activities) ? res.activities : [];
      } catch (e) {
        dbgw('[Okendo][earn] activities fetch failed (using cache if any):', e?.message || e);
        try {
          const cached = JSON.parse(sessionStorage.getItem(`ok-acts:${email}`) || 'null');
          return cached || empty;
        } catch { return empty; }
      }

      // 3c) log RAW activities so we can inspect exactly what Okendo returns
      try {
        console.groupCollapsed(`[Okendo][activities] raw (${activities.length})`);
        console.table(activities.map(a => ({
          date: a?.date,
          namespace: a?.namespace || '—',
          title: a?.title || '—',
          id: a?.activityId?.slice?.(0,8) || '—'
        })));
        console.groupEnd();
      } catch(_){}

      // 3d) map activity titles → tiles; be forgiving on text
      const titleToKeyMap = [
        [/joined program|create an account|created an account/i, 'join_program'],
        [/liked? on facebook/i,                               'facebook_like'],
        [/followed? on instagram/i,                           'instagram_follow'],
        [/follow(ed)? on tiktok|tiktok/i,                     'tiktok_follow'],
        [/write a review|left? a review/i,                    'write_review'],
        [/review.*(photo|image|video)|ugc/i,                  'review_ugc'],
        [/birthday/i,                                         'birthday'],
        [/anniversar/i,                                       'anniversary'],
        [/refer(red)? a friend|referral/i,                    'refer_friend'],
        [/placed? an order|purchase/i,                        'place_order']
      ];

      const completedByKey = new Set();
      const completedByAction = new Set();
      const completedByActionCat = new Set();

      for (const a of activities) {
        const t = lower(a?.title || '');
        if (!t) continue;

        let keyHit = null;
        for (const [re, k] of titleToKeyMap) {
          if (re.test(t)) { keyHit = k; break; }
        }
        if (!keyHit) continue;

        completedByKey.add(keyHit);

        const action   = KEY_TO_ACTION[keyHit];
        const category = KEY_TO_CATEGORY[keyHit];
        if (action) completedByAction.add(lower(action));
        if (action && category) completedByActionCat.add(actKey(action, category));
      }

      const out = {
        completedByActionId: [], // activities don’t include actionId
        completedByKey:      [...completedByKey],
        completedByAction:   [...completedByAction],
        completedByActionCat:[...completedByActionCat]
      };

      // cache to soften intermittent CORS blocks
      try { sessionStorage.setItem(`ok-acts:${email}`, JSON.stringify(out)); } catch(_){}
      return out;
    }

    let completedByActionId = new Set();
    let completedByKey      = new Set();
    let completedByAction   = new Set();
    let completedByActCat   = new Set();

    try {
      const c = await buildCompletionsFromActivities(email);   // <— NEW
      completedByActionId = new Set(c.completedByActionId || []);
      completedByKey      = new Set(c.completedByKey || []);
      completedByAction   = new Set((c.completedByAction || []).map(lower));
      (c.completedByActionCat || []).forEach(ac => completedByActCat.add(lower(ac)));
    } catch (e) {
      dbgw('[Okendo][earn] completion scan failed:', e?.message || e);
    }
    // ---------- END step 3 ------------------------------------------------------

    // 4) Wire tiles (unchanged except they now benefit from the completion sets)
    let wired = 0, disabled = 0;

    document.querySelectorAll('[data-earn-tile]').forEach(tile => {
      const btn = tile.querySelector('[data-earn-btn]');
      if (!btn) return;

      const tileKey = btn.dataset.earn || '';
      const fallbackAction   = KEY_TO_ACTION[tileKey];
      const fallbackCategory = KEY_TO_CATEGORY[tileKey];

      const ruleRaw = byKey[tileKey] ||
                      byActionCat[actKey(fallbackAction, fallbackCategory)] ||
                      byAction[lower(fallbackAction)];
      const s = ruleRaw ? summarizeRule(ruleRaw) : null;

      let actionId = (
        btn?.dataset?.actionId ||
        tile?.dataset?.actionId ||
        tile?.getAttribute('data-okendo-action-id') ||
        (s && s.actionId) || null
      );
      if (typeof actionId === 'string' && /^OKENDO_ACTION_ID_/i.test(actionId)) actionId = null;

      let action = (
        btn?.dataset?.okAction ||
        tile?.dataset?.okAction ||
        (s && s.action) ||
        fallbackAction || null
      );
      let actionCategory = (
        btn?.dataset?.okActionCategory ||
        tile?.dataset?.okActionCategory ||
        (s && s.actionCategory) ||
        fallbackCategory || null
      );

      // Social default links
      if (['facebook_like','instagram_follow','tiktok_follow'].includes(tileKey)) {
        const forced = isMember ? {
          facebook_like:   'https://www.facebook.com/DrakeWaterfowl/',
          instagram_follow:'https://www.instagram.com/drakewaterfowl'
        }[tileKey] : null;
        const url =
          forced ||
          tile.dataset.url ||
          btn.dataset.url ||
          btn.getAttribute('href') ||
          null;
        if (url) btn.dataset.destUrl = url;
      }

      console.log('[Okendo][earn][tile]', {
        tileKey,
        matchedTitle: s?.title || null,
        matchedType: s?.type || null,
        matchedActionId: actionId || null,
        matchedAction: action || null,
        matchedActionCategory: actionCategory || null
      });

      // (A) Join program auto-complete
      if (tileKey === 'join_program' && isMember) {
        markTileComplete(tile, btn, 'Completed');
        wired++; return;
      }

      // (B) Completed? (actionId | action|category | action | key)
      const acKey = (action && actionCategory) ? actKey(action, actionCategory) : null;
      if ((actionId && completedByActionId.has(actionId)) ||
          (acKey    && completedByActCat.has(acKey))      ||
          (action   && completedByAction.has(lower(action))) ||
          completedByKey.has(tileKey)) {
        markTileComplete(tile, btn, 'Completed');
        wired++; return;
      }

      // (C) Navigation helpers
      if (tileKey === 'place_order' || (s && /points?-?per-?spend/i.test(s.type || ''))) {
        armEarnBtn(btn, () => { window.location.href = '/collections/all'; });
        wired++; return;
      }
      if (tileKey === 'write_review' || (s && /submit-?review|review/i.test((s.type || '') + ' ' + (s.action || '')))) {
        armEarnBtn(btn, () => {
          const target = document.querySelector('#oke-reviews,[data-oke-reviews],#shopify-product-reviews');
          if (target) target.scrollIntoView({ behavior: 'smooth' });
          else window.location.href = '/pages/reviews';
        });
        wired++; return;
      }
      if (tileKey === 'refer_friend' || (action && /refer|referral/i.test(action))) {
        armEarnBtn(btn, () => {
          const target = document.querySelector('#refer-a-friend,[data-referral-section]');
          if (target) target.scrollIntoView({ behavior: 'smooth' });
        });
        wired++; return;
      }

      // (D) Social links should still work even if we can’t award here
      if (['facebook_like','instagram_follow','tiktok_follow'].includes(tileKey)) {
        const url = btn.dataset.destUrl;
        if (url) {
          armEarnBtn(btn, () => { window.open(url, '_blank', 'noopener,noreferrer'); });
          if (!actionId) { wired++; return; }
        }
      }

      // (E) If we have neither actionId nor action, disable
      if (!actionId && !action) {
        hardDisableBtn(btn);
        btn.title = 'Missing Okendo action/actionId';
        tile.classList.add('is-disabled');
        console.warn(`[Okendo][earn] ${tileKey}: disabled (no action/actionId).`);
        disabled++; return;
      }

      // (F) Generic award attempt if we DO have an actionId
      armEarnBtn(btn, async (_, el) => {
        const dest = el.dataset.destUrl;
        if (dest) { try { window.open(dest, '_blank', 'noopener,noreferrer'); } catch(_) {} }

        if (!actionId) return;

        const original = el.textContent;
        el.textContent = 'Working…';
        el.disabled = true;

        const body = { actionId, customerIdentifier: { email: getShopifyCustomerEmail() } };

        try {
          const res = await fetchJson(`${OKENDO_BASE}/loyalty/earning_transactions`, {
            method: 'POST',
            body: JSON.stringify(body)
          });
          const newBal = res?.loyaltyCustomer?.points?.balance;
          const balEl = document.querySelector('[data-points-balance], #okendo-points');
          if (typeof newBal === 'number' && balEl) balEl.textContent = Math.floor(newBal);

          markTileComplete(tile, el, 'Completed');
          toast('Points awarded!');
        } catch (e) {
          if (String(e?.message || '').includes(' 422 ')) {
            markTileComplete(tile, el, 'Completed'); // already awarded
          } else {
            el.textContent = original;
            el.disabled = false;
            toast('Could not award points.');
            dbge('[Okendo][earn] award error:', e);
          }
        }
      });

      wired++;
    });

    __ok_waysWired = true;
    console.log(`[Okendo][earn] wired ${wired} earn tiles, ${disabled} disabled (missing action/actionId)`);
  }

  // === Okendo Earn: add/rename "Join" buttons ONLY inside #oke-loyalty-earn ===
  (function okendoJoinButtons(){
    if (window.__OK_JOIN_BTNS_INSTALLED) return;
    window.__OK_JOIN_BTNS_INSTALLED = true;

    const VER = '1.4.5-nonmember-scoped';
    const ROOT_ID = 'oke-loyalty-earn';
    const DBG = () => !!window.OKENDO_DEBUG;
    const log = (...a) => { if (DBG()) console.log('[Okendo][join]', ...a); };

    // Keep track of only what we modify inside the embed
    const touched  = new Set(); // renamed/retargeted existing CTAs
    const injected = new Set(); // brand-new buttons we injected
    let rootMO = null, stateMO = null;

    function getRoot(){ return document.getElementById(ROOT_ID) || null; }

    function pageState(){
      const root = document.querySelector('.okendo-loyalty-root, #okendo-loyalty-root');
      const s = (root && root.getAttribute('data-loyalty-state')) ||
                document.body.getAttribute('data-loyalty-state') || '';
      return String(s || '').toLowerCase();
    }
    function isMember(){
      const st = pageState();
      if (st === 'member') return true;
      if (st === 'non-member') return false;
      try {
        if (typeof window.OKENDO_IS_MEMBER === 'function') return !!window.OKENDO_IS_MEMBER();
        if (window.OKENDO_MEMBER_STATE) return String(window.OKENDO_MEMBER_STATE).toLowerCase() === 'member';
        if (window.__okendoMember === true) return true;
        const d = window.__okendoMemberData || window.okendoMemberData;
        if (d && (d.id || d.memberId || d.points != null)) return true;
        const attr = (document.documentElement.getAttribute('data-okendo-member') || document.body.getAttribute('data-okendo-member') || '');
        return /^(1|true|member|yes)$/i.test(attr);
      } catch(_) { return false; }
    }

    function markJoin(el){
      if (!el) return;
      if (!el.dataset.okPrevText) el.dataset.okPrevText = el.textContent || '';
      if (el.tagName === 'A' && !el.dataset.oldHref) el.dataset.oldHref = el.getAttribute('href') || '';
      if (!/join/i.test(el.textContent || '')) el.textContent = 'Join';
      if (el.tagName === 'A') el.setAttribute('href', '#'); // opener handles it for guests
      el.classList.add('ok-open-join');
      el.dataset.okRenamed = '1';
      touched.add(el);
    }
    function restore(el){
      if (!el) return;
      try {
        if (el.dataset.okPrevText != null){ el.textContent = el.dataset.okPrevText; delete el.dataset.okPrevText; }
        if (el.tagName === 'A' && el.dataset.oldHref != null){ el.setAttribute('href', el.dataset.oldHref); delete el.dataset.oldHref; }
        el.classList.remove('ok-open-join');
        el.removeAttribute('data-ok-renamed');
      } catch(_) {}
      touched.delete(el);
    }
    function teardown(root){
      // Only restore/remove elements that live under the embed root
      touched.forEach(el => { if (root && root.contains(el)) restore(el); });
      injected.forEach(el => { if (root && root.contains(el)) try{ el.remove(); }catch(_){} });
      injected.clear();
      if (rootMO){ try{ rootMO.disconnect(); }catch(_){ } rootMO = null; }
      // keep state observer so we can reapply if they log out later
      log('teardown complete @', VER);
    }

    function ensureForGuest(root){
      if (!root) return;
      if (isMember()) { teardown(root); return; }

      // 1) Rename existing CTAs inside the embed ONLY
      root.querySelectorAll('.c-actionCard .c-actionCard-action .c-button').forEach(btn => {
        if (btn.dataset.okRenamed === '1') return;
        const label = (btn.textContent || '').trim();
        if (/^go$/i.test(label) || !/join/i.test(label)) markJoin(btn);
      });

      // 2) Inject a Join button for any card that lacks a CTA
      root.querySelectorAll('.c-actionCard').forEach(card => {
        if (card.querySelector('.c-actionCard-action .c-button, .ok-open-join')) return;

        let action = card.querySelector('.c-actionCard-action');
        if (!action){
          action = document.createElement('div');
          action.className = 'c-actionCard-action';
          card.appendChild(action);
        }

        const a = document.createElement('a');
        a.className = 'c-button c-button--stretch ok-open-join';
        a.href = '#';
        a.textContent = 'Join';
        a.dataset.okCustomJoin = '1';
        action.appendChild(a);
        injected.add(a);
      });

      // 3) Observe only the embed subtree for late-rendered cards
      if (!rootMO){
        rootMO = new MutationObserver(() => ensureForGuest(root));
        rootMO.observe(root, { childList: true, subtree: true });
        log('observer attached (scoped) @', VER);
      }
    }

    // Boot: wait for the embed root, then scope everything to it
    (function boot(){
      const root = getRoot();
      if (root){
        ensureForGuest(root);
        // watch login state flips (data-loyalty-state on body)
        if (!stateMO){
          stateMO = new MutationObserver(() => ensureForGuest(getRoot()));
          stateMO.observe(document.body, { attributes: true, attributeFilter: ['data-loyalty-state'] });
        }
        return;
      }
      // root not present yet — wait until it appears
      const mo = new MutationObserver(() => {
        const r = getRoot();
        if (r){ try{ mo.disconnect(); }catch(_){ } ensureForGuest(r); }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      // gentle retries
      setTimeout(() => ensureForGuest(getRoot()), 300);
      setTimeout(() => ensureForGuest(getRoot()), 900);
      window.addEventListener('load', () => ensureForGuest(getRoot()), { once: true });
    })();
  })();

  // === Okendo widget opener (non-member only, gated) ===========================
  (function okendoWidgetOpener(){
    if (window.__OK_OPEN_JOIN_INSTALLED) return;
    window.__OK_OPEN_JOIN_INSTALLED = true;

    const VER = '1.4.2-nonmember-gated';
    const DBG = () => !!window.OKENDO_DEBUG;
    const log = (...a) => { if (DBG()) console.log('[Okendo][opener]', ...a); };

    function bodyOrRootState(){
      const roots = document.querySelectorAll('.okendo-loyalty-root, #okendo-loyalty-root');
      for (const r of roots) {
        const s = (r.getAttribute('data-loyalty-state') || '').toLowerCase();
        if (s) return s; // 'member' | 'non-member'
      }
      return (document.body.getAttribute('data-loyalty-state') || '').toLowerCase();
    }

    function isMember(){
      try {
        // 1) Prefer explicit state set after API resolution
        const state = bodyOrRootState();
        if (state === 'member') return true;
        if (state === 'non-member') return false;

        // 2) Heuristics (unchanged)
        if (typeof window.OKENDO_IS_MEMBER === 'function') return !!window.OKENDO_IS_MEMBER();
        if (window.OKENDO_MEMBER_STATE) return String(window.OKENDO_MEMBER_STATE).toLowerCase() === 'member';
        if (window.__okendoMember === true) return true;
        const d = window.__okendoMemberData || window.okendoMemberData;
        if (d && (d.id || d.memberId || d.points != null)) return true;
        const attr = (document.documentElement.getAttribute('data-okendo-member') || document.body.getAttribute('data-okendo-member') || '');
        return /^(1|true|member|yes)$/i.test(attr);
      } catch(_) { return false; }
    }

    // Click should only be hijacked if the trigger sits in an explicit non-member region,
    // or the page's state says non-member. Otherwise, let it behave normally.
    function inNonMemberRegion(el){
      try {
        const gate = el.closest('[data-visible-when], [data-hide-when]');
        if (gate) {
          const v = (gate.getAttribute('data-visible-when') || '').toLowerCase();
          const h = (gate.getAttribute('data-hide-when') || '').toLowerCase();
          if (/\bnon-member\b/.test(v)) return true;
          if (/\bmember\b/.test(h))     return true;
          if (/\bmember\b/.test(v))     return false;
          if (/\bnon-member\b/.test(h)) return false;
        }
      } catch(_) {}
      const state = bodyOrRootState();
      if (state === 'non-member') return true;
      if (state === 'member')     return false;
      return false; // safe default: do not intercept unless clearly non-member
    }

    const LAUNCHER_SELECTORS = [
      'button[aria-controls="oke-rewards-widget"]',
      '.c-launchBubble-button.c-button',
      '[data-oke-rewards-launcher] .c-button',
    ];
    function findLauncher(){
      for (const s of LAUNCHER_SELECTORS){ const el = document.querySelector(s); if (el) return el; }
      return null;
    }

    function openWidgetNow(){
      const btn = findLauncher();
      if (!btn) { log('launcher not found'); return false; }
      const expanded = btn.getAttribute('aria-expanded');
      if (expanded === 'true') { log('already open; no click'); return true; }
      try { btn.click(); log('launcher clicked (opening)'); return true; }
      catch (e) { log('launcher click error', e); return false; }
    }

    function openWhenReady(maxMs = 5000, stepMs = 120){
      const start = Date.now();
      (function tick(){
        const btn = findLauncher();
        if (btn) {
          const expanded = btn.getAttribute('aria-expanded');
          if (expanded === 'true') { log('ready & already open'); return; }
          if (openWidgetNow()) return;
        }
        if (Date.now() - start >= maxMs) { log('launcher not found within timeout'); return; }
        setTimeout(tick, stepMs);
      })();
    }

    // simple debounce to prevent rapid double toggles
    let squelchUntil = 0;

    function handleActivate(e, src){
      const trigger = e.target && e.target.closest && e.target.closest('.ok-open-join');
      if (!trigger) return;

      const member = isMember();
      const gated  = inNonMemberRegion(trigger);
      log(`activation on ${src} | isMember=`, member, '| gatedNonMember=', gated, '| el=', trigger);

      // Only intercept clicks if we’re explicitly in NON-MEMBER UI/state
      if (member || !gated) return;

      if (src === 'keydown' && !(e.key === 'Enter' || e.key === ' ' || e.code === 'Space')) return;

      const now = Date.now();
      if (now < squelchUntil){ // prevent double fires
        e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        log('squelched duplicate event');
        return;
      }

      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      squelchUntil = now + 500;
      openWhenReady();
    }

    // IMPORTANT: only 'click' + keyboard — no pointerdown
    document.addEventListener('click',   (e) => handleActivate(e, 'click'),   { capture: true });
    document.addEventListener('keydown', (e) => handleActivate(e, 'keydown'), { capture: true });

    // Debug helpers
    window.openOkendoWidget = () => openWhenReady();
    window.__okendoOpenerDiag = () => {
      const btn = findLauncher();
      console.log('[Okendo][opener][diag]', {
        version: VER,
        isMember: isMember(),
        state: bodyOrRootState(),
        launcherFound: !!btn,
        launcherSel: btn && btn.matches ? LAUNCHER_SELECTORS.find(s => btn.matches(s)) : null,
        ariaExpanded: btn && btn.getAttribute && btn.getAttribute('aria-expanded')
      });
    };

    log('installed @', VER, '| isMember=', isMember(), '| state=', bodyOrRootState());
  })();

  /** Minimal fetch wrapper if you ever need it elsewhere */
  function okendoFetch(path, opts = {}) {
    const headers = Object.assign(
      { 'Content-Type': 'application/json' },
      BASIC_AUTH ? { Authorization: BASIC_AUTH } : {}
    );
    return fetch(`${OKENDO_BASE}${path}`, { credentials: 'omit', headers, ...opts });
  }

  /* ===== init ===== */
  function initTabsPublic(){ initTabs(); }
  initTabsPublic();
  forEachScope(updateHeadingsForState);
  updateTierUI();
  loadOkendoData();
  loadPointHistoryIfNeeded();
});
